import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import {
  fetchPost,
  fetchlogo,
  same,
} from "./apiFolder/index";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  LinkedinIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useLocation } from "react-router-dom";
import { Shimmer } from "react-shimmer";
import { debounce } from 'lodash';

export default function App() {
  const [posts, setPosts] = useState([]);
  const [logo, setLogo] = useState([]);
  const [interactions, setInteraction] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isShareOption, setIsShareOption] = useState(false);
  const [showModalsupport, setShowModalSupport] = useState(false);
  const [postIndex, setPostIndex] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [liked, setLiked] = useState(Array(posts.length).fill(false));
  const [help, setHelp] = useState(Array(posts.length).fill(false));
  const [thumbs, setThumbs] = useState(Array(posts.length).fill(false));
  const [share, setShare] = useState(Array(posts.length).fill(false));
  const [support, setSupport] = useState(Array(posts.length).fill(false));
  const [cardCount, setCardCount] = useState(
    new Array(interactions.length).fill(0)
  );

  const cardRef = useRef(null);
  const [lastProcessedIndex, setLastProcessedIndex] = useState(-1);
  const [hasApiHit, setHasApiHit] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  //   const { 0: school_id } = useLocation().pathname.split("/").slice(-1);
  const pathSegments = useLocation().pathname.split("/");
  const school_id = pathSegments[pathSegments.length - 2];
  const debouncedUpdateViewCount = debounce(viewIncrement, 200);


  useEffect(() => {
    // if (hasMore) {
    fetchPost(school_id)
      .then((res) => {
        setPosts([res.data.body.data[0]]);
        setHasMore(res.data.body.data.length > 0);
        setInteraction(res.data.body.data);
        setLiked(new Array(res.data.length).fill(false));
        setHelp(new Array(res.data.length).fill(false));
        setThumbs(new Array(res.data.length).fill(false));
        setShare(new Array(res.data.length).fill(false));
        setSupport(new Array(res.data.length).fill(false));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    // }


    console.log('posts::::::::::::::::', posts);
    // Fetch Logo

    fetchlogo(school_id)
      .then((res) => {
        // console.log("logo00", res.data.body);
        setLogo(res.data.body);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const postData = async (notificationId, title, field) => {
    try {
      // console.log("event", event);
      // const notificationId = event;
      const data = {
        Notification_Id__c: notificationId,
        Title__c: title,
        Like__c: "0",
        Thanks__c: "0",
        Share__c: "0",
        Helpful__c: "0",
        Support__c: "0",
        View__c: "0",
        Test_School__c: false,
      };

      if (field === "Like") {
        data.Like__c = "1";
      } else if (field === "Share") {
        data.Share__c = "1";
      } else if (field === "Helpful") {
        data.Helpful__c = "1";
      } else if (field === "Thanks") {
        data.Thanks__c = "1";
      } else if (field === "Support") {
        data.Support__c = "1";
      } else if (field === "view") {
        data.View__c = "1";
      }
      same(data, school_id)
        .then((respost) => {
          console.log("postData", respost);
          // fetchInteraction(school_id)
          //   .then((res) => {
          //     // console.log(res.data.body);
          //     setInteraction(res.data.body);
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Use Effect of Scroliing
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // View Increment useEffect
  useEffect(() => {
    console.log('lastProcessedIndex has been updated:', lastProcessedIndex);
    // viewIncrement();
    debouncedUpdateViewCount()
  }, [debouncedUpdateViewCount, lastProcessedIndex]);

  useEffect(() => {
    const cardElement = cardRef.current;
    if (cardElement) {
      cardElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (cardElement) {
        cardElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  function viewIncrement() {
    const cardElement = cardRef.current;

    if (cardElement) {
      const childElement = cardElement.querySelector(".card");

      if (childElement) {
        const mainWidth = cardElement.clientWidth;
        const mainHeight = cardElement.clientHeight;
        const scrollTop = cardElement.scrollTop;
        // console.log('77777777777',scrollTop);

        const cardWidth = childElement.clientWidth;
        const cardHeight = childElement.clientHeight;

        const totalCol = Math.floor(mainWidth / cardWidth);
        const totalRow = Math.floor(mainHeight / cardHeight);

        const totalDisplayedItems = totalCol * totalRow;

        const xone = Math.floor(scrollTop / cardHeight);
        const xtwo = cardHeight - xone;
        const xthree = scrollTop - xtwo;

        let startIndex = xone * totalDisplayedItems;
        const endIndex = startIndex + totalDisplayedItems - 1;

        if (scrollTop === 0 && !hasApiHit) {
          setLastProcessedIndex(-1);
          setHasApiHit(true);
        } else if (scrollTop > 0) {
          setHasApiHit(false);
        }
        const isLastCardFullyVisible =
          (scrollTop + mainHeight) >=
          (cardElement.scrollHeight - childElement.clientHeight);
        // if(xthree > cardHeight - 500){
        if (startIndex > lastProcessedIndex || endIndex < lastProcessedIndex) {
          // if (isLastCardFullyVisible && startIndex > lastProcessedIndex) {
          console.log('lastProcessedIndex:', lastProcessedIndex);
          console.log('endIndex', endIndex);
          console.log('startIndex', startIndex);
          if (isLastCardFullyVisible) {
            setLastProcessedIndex(startIndex);
          }

          console.log(
            "start to end",
            startIndex,
            startIndex + totalDisplayedItems
          );
          posts
            .slice(startIndex, startIndex + totalDisplayedItems)
            .forEach((post, index) => {
              // console.log('indeeeeeeeexxx',index);
              if (startIndex + index > lastProcessedIndex) {
                let codeExecuted = false;
                let newschoolId;
                interactions.forEach((respp, indexx) => {
                  //  console.log("----------", interactions);
                  let newid = post.id;
                  let schoopAppC = school_id;
                  newschoolId = newid.concat(schoopAppC);
                  console.log('newschoolId:::', newschoolId);
                  console.log('newid:::', newid.id);
                  if (newid === respp.id) {
                    console.log("post::::::::::::::", post);
                    postData(
                      respp.id,
                      post.title,
                      "view"
                    );
                    codeExecuted = true;
                    return;
                  }
                });
                if (!codeExecuted) {
                  console.log("postData", post);
                  postData(newschoolId, post.title, "view");
                }
              }
            });
          // Update lastProcessedIndex after processing the posts
          setLastProcessedIndex(endIndex);
        }
        else if (startIndex <= lastProcessedIndex) {
          console.log(
            "startIndex is less than or equal to lastProcessedIndex. API will not be hit."
          );
        }
      }
    }
  }
  // Scrolling Functionality
  function handleScroll(event) {
    debouncedUpdateViewCount();
  }
  // modal--------------Startt
  const handleClick = (index) => {
    setShowModal(true);
    setPostIndex(index);
    setImageLoaded(false);
    document.documentElement.style.overflowY = "hidden";
  };
  // Close Modal
  const closeModal = () => {
    setShowModal(false);
    document.documentElement.style.overflowY = "hidden";
  };
  const handleClickOutside = (e) => {
    // Check if the click event originated from the child modal of showModalsupport modal
    if (showModalsupport && e.target.classList.contains("sharemodal")) {
      closeModalsupport();
    }
    // Check if the click event originated from the child modal of isShareOption modal
    else if (isShareOption && e.target.classList.contains("sharemodal")) {
      closeModalshare();
    }
    // Check if the click event originated from the parent modal, but not the child modal of isShareOption or showModalsupport modal
    else if (
      !showModalsupport &&
      !isShareOption &&
      e.target.classList.contains("modal") &&
      !e.target.classList.contains("sharemodal")
    ) {
      closeModal();
    }
  };
  useEffect(() => {
    if (showModal || isShareOption || showModalsupport) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, isShareOption, showModalsupport]);
  // Modal ---------- End
  // Close Modal of Share
  const closeModalshare = () => {
    console.log("-------------", closeModalshare);
    setIsShareOption(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  const openSupportModel = () => {
    setShowModalSupport(true);
    document.body.style.overflow = "hidden"; // disable background scroll
  };
  const openShareModal = () => {
    setIsShareOption(true);
    document.body.style.overflow = "hidden"; // disable background scroll
  };
  // Close Modal of Share
  const closeModalsupport = () => {
    console.log("-------------", closeModalshare);
    setShowModalSupport(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  // Crad Share Url
  const shareCard = (index) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set("index", index);
    return url.toString();
  };
  // COunt INcrement
  const handleClickin = (event, ind) => {
    const countEl = event.target.parentElement.nextSibling;
    const countStr = countEl.innerHTML.trim(); // remove any leading/trailing whitespace
    const count = parseInt(countStr);

    if (!isNaN(count)) {
      console.log("event", count + 1);
      countEl.innerHTML = count + 1;
    }

    setCardCount((prevCardCount) => {
      const newCardCount = [...prevCardCount];
      newCardCount[ind] += 1;
      return newCardCount;
    });
    // fetchInteraction(school_id)
    //   .then((res) => {
    //     // console.log(res.data.body);
    //     setInteraction(res.data.body);
    //     setLiked(new Array(res.data.length).fill(false));
    //     setHelp(new Array(res.data.length).fill(false));
    //     setThumbs(new Array(res.data.length).fill(false));
    //     setShare(new Array(res.data.length).fill(false));
    //     setSupport(new Array(res.data.length).fill(false));
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  // love Button ANimation
  const handleLikeClick = (ind) => {
    // setLiked((liked) => {
    //   const newLiked = [...liked];
    //   newLiked[ind] = !liked[ind];
    //   return newLiked;
    // });
    const newLikedState = [...liked];
    newLikedState[ind] = true;
    // newLikedState[ind] = !newLikedState[ind];
    setLiked(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setLiked(newLikedState);
    }, 1000);
  };
  // Thumbs-Up buttom
  const handleThumbsClick = (ind) => {
    const newLikedState = [...thumbs];
    newLikedState[ind] = true;
    // newLikedState[postIndex] = !newLikedState[postIndex];
    setThumbs(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setThumbs(newLikedState);
    }, 1000);
  };
  // helpfull button
  const handleHelpfulClick = (ind) => {
    const newLikedState = [...help];
    newLikedState[ind] = true;
    // newLikedState[postIndex] = !newLikedState[postIndex];
    setHelp(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setHelp(newLikedState);
    }, 1000);
  };
  // Share Button
  const handleShareClick = (ind) => {
    const newLikedState = [...share];
    newLikedState[ind] = true;
    // newLikedState[postIndex] = !newLikedState[postIndex];
    setShare(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setShare(newLikedState);
    });
  };
  // Support Button
  const handleSupportClick = (ind) => {
    const newLikedState = [...support];
    newLikedState[ind] = true;
    // newLikedState[postIndex] = !newLikedState[postIndex];
    setSupport(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setSupport(newLikedState);
    });
  };
  // NUmber Format
  function NumberFormat(number) {
    // console.log ('number',typeof number)
    if (number === 0) {
      return "0";
    }
    const suffixes = ["", "k", "M", "B", "T"];
    const magnitude = Math.floor(Math.log10(number) / 3);
    const divisor = 10 ** (magnitude * 3);
    const suffix = suffixes[magnitude];
    const shortNumber = (number / divisor).toLocaleString(undefined, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    });

    // console.log('Shorthand number ----------- ', parseInt(shortNumber) + suffix,  suffix);
    return parseFloat(shortNumber) + suffix;
  }
  //Linkify
  const linkify = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/gi;
    return text.split(urlRegex).map((word, index) => {
      // check if the word is a Twitter URL-like text and create a link for it
      if (/^pic.twitter.com\/\w+$/i.test(word)) {
        return (
          <a
            href={`https://${word}`}
            target="_blank"
            rel="noopener noreferrer"
            key={index}
          >
            {word}
          </a>
        );
      }
      if (urlRegex.test(word)) {
        return (
          <a href={word} target="_blank" rel="noopener noreferrer" key={index}>
            {word}
          </a>
        );
      }
      return word;
    });
  };
  // Support Email
  function handleEmailClick(email) {
    window.location.href = `mailto:${email}`;
  }
  // Support Calll
  function handlePhoneClick(phoneNumber) {
    //setPhoneCopySuccess(false); // reset phone copy success state
    window.location.href = `tel:${phoneNumber}`; // initiate phone call
  }

  function handleClickNext() {
    if (postIndex === posts.length - 1) {
      // do nothing, as we don't want to go forward from the last index
      return;
    } else {
      setPostIndex((postIndex + 1) % posts.length);
      setImageLoaded(false);
    }
  }
  function handleClickPrev() {
    if (postIndex === 0) {
      // setPostIndex(posts.length - 1);
      return;
    } else {
      setPostIndex((postIndex - 1) % posts.length);
      setImageLoaded(false);
    }
  }
  // Interactions
  function returnInteraction(post, index) {
    let newid = post.id;
    let newschoolId = "";
    for (var i in interactions) {
      let schoopAppC = school_id;
      newschoolId = newid.concat(schoopAppC);
      if (newid === interactions[i].id) {
        return (
          <>
            <div className="flex flex-col flex-row">
              <div className="flex justify-center gap-4 md:gap-3 relative">
                <div key={i} className=" text-sm mb-2 flex gap-1">
                  <button
                    id="like-button"
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Like"
                      );
                      handleClickin(event);
                      handleLikeClick(index);
                    }}
                  >
                    {liked[index] ? (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="likesanimation HeartAnimation"
                      >
                        <g clip-path="url(#clip0_107_13)">
                          <path
                            d="M1.5 9.5C2.3 14.3 8.83333 20.1667 12 22.5L16 19.5C17.6666 18 21.4 13.7 23 8.5C23.4 0.900004 17.5 0.666671 14.5 1.5C14.1667 1.66667 13.1 2.3 11.5 3.5C6.5 -1.5 0.5 3.5 1.5 9.5Z"
                            fill="#F54438"
                          />
                          <path
                            d="M6.2812 0.0143438C5.07183 0.191295 4.08745 0.582733 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.4972C23.3296 3.24773 21.2531 0.834754 18.4031 0.132311C17.7703 -0.0231918 16.4578 -0.0339152 15.8203 0.110863C14.5312 0.40042 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765046 9.05152 0.293177 8.17027 0.116226C7.76245 0.0304316 6.59995 -0.0285535 6.2812 0.0143438ZM7.61714 1.75705C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56146 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56146 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829393 20.6578 2.13776 21.9609 5.24781C23.1796 8.15947 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75705Z"
                            fill="#F54438"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_107_13">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_4_37)">
                          <path
                            d="M6.2812 0.0143425C5.07183 0.191294 4.08745 0.582731 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.49719C23.3296 3.24773 21.2531 0.834753 18.4031 0.13231C17.7703 -0.0231931 16.4578 -0.0339165 15.8203 0.110862C14.5312 0.400418 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765044 9.05152 0.293176 8.17027 0.116225C7.76245 0.0304303 6.59995 -0.0285548 6.2812 0.0143425ZM7.61714 1.75704C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56145 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56145 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829392 20.6578 2.13776 21.9609 5.24781C23.1796 8.15946 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75704Z"
                            fill="#F54438"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_37">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {liked[index] && <span className="namepop">Like</span>}
                  <span className="figures figures-size">
                    {interactions[i].interactions.likes !== undefined && interactions[i].interactions.likes !== null
                      ? NumberFormat(interactions[i].interactions.likes)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    id="share-button"
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Thanks"
                      );
                      handleClickin(event);
                      handleThumbsClick(index);
                    }}
                  >
                    {thumbs[index] ? (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_107_16)">
                          <path
                            d="M0.5 21C0.5 23.4 2.83333 23.3334 4 23L6 22.5L7 22L12.5 23.5H21C22.2 23.5 22.1667 21.1667 22 20C22.5 19.6667 23.5 18.8 23.5 18C23.5 17.2 22.5 16.6667 22 16.5C22.3333 16.3334 23 15.7 23 14.5C23 13.3 22 13 21.5 13C22 13 23.1 12.7 23.5 11.5C23.9 10.3 22.3333 9.66669 21.5 9.50003H14.5L15 8.00002C15.1667 7.00003 15.3 4.40006 14.5 2.00006C13.5 -0.999944 11 1.00006 11 3.50006C11 6.00006 8 9.50003 8 10C8 10.4 7 10.5 6.5 10.5001C6.23238 10.3334 5.65772 9.90003 5.5 9.50003C5.34228 9.10003 3.43428 9.33336 2.5 9.50003L0.5 10V21Z"
                            fill="#2295F1"
                          />
                          <path
                            d="M12.1744 0.0286915C11.3391 0.193104 10.9325 0.862092 10.6373 2.57425C10.1305 5.52233 9.55688 7.08141 8.47087 8.49309C7.98635 9.12239 6.87806 10.1939 6.80009 10.1089C6.78895 10.0975 6.72769 9.98414 6.66643 9.85375C6.60517 9.72902 6.44923 9.53059 6.32113 9.41153C5.87002 8.99767 5.94242 9.00901 3.42511 9.00901C1.24195 9.00901 1.15841 9.01468 0.913362 9.12806C0.590344 9.28114 0.300741 9.57595 0.133663 9.92178L0 10.1996V22.3321L0.15594 22.6552C0.323018 23.0011 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68623 23.517 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6496C6.7444 22.5192 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62682 23.2619 10.2753 23.7494 11.5952 23.9195C12.2079 23.9989 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9989 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5746C22.305 20.5065 22.3662 20.4442 22.7115 20.2741C23.3631 19.9453 23.8588 19.2649 23.9758 18.5393C24.076 17.9156 23.8588 17.1673 23.4467 16.7024L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25279 22.1435 8.92397C21.9597 8.88995 20.5005 8.86727 18.4287 8.86727C15.7276 8.86727 15.0092 8.85026 15.0092 8.79357C15.0092 8.75955 15.1819 8.06222 15.3935 7.25149C15.9059 5.27855 15.9226 5.20485 15.917 4.38845C15.9114 3.82718 15.8836 3.56639 15.7722 3.12985C15.5104 2.10936 14.9368 1.16257 14.2685 0.652324C13.6392 0.170426 12.7815 -0.0903657 12.1744 0.0286915ZM13.0989 1.28163C14.0012 1.62179 14.6583 2.68764 14.8087 4.07664C14.8755 4.63791 14.7586 5.28422 14.2239 7.30819C13.9455 8.36836 13.7171 9.33216 13.7116 9.44555C13.706 9.60996 13.7394 9.695 13.8564 9.81406L14.0067 9.9728L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7757 22.305 12.2122C22.0599 12.3483 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7395 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5162L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5175C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8158L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0709 22.6336 17.4677C23.0902 18.0347 22.8842 18.9418 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3727 19.1583 19.4407C18.8186 19.6108 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3683 21.6199 22.5589 20.7623 22.814C20.6119 22.8593 19.2697 22.8707 16.1231 22.8537C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V11.5546L7.43499 11.084C8.69365 10.1315 9.62372 9.01468 10.2976 7.6767C10.9325 6.41243 11.3056 5.16516 11.6621 3.14119C11.9294 1.63313 12.0631 1.26462 12.3916 1.13989C12.503 1.10021 12.7425 1.14556 13.0989 1.28163ZM5.56371 10.2336L5.70851 10.347V22.1847L5.56371 22.2981C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.11386 22.145V10.3867L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                            fill="#2295F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_107_16">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_4_46)">
                          <path
                            d="M12.1744 0.0286594C11.3391 0.193072 10.9325 0.86206 10.6373 2.57422C10.1305 5.5223 9.55688 7.08138 8.47088 8.49306C7.98635 9.12236 6.87806 10.1939 6.80009 10.1088C6.78895 10.0975 6.72769 9.98411 6.66643 9.85371C6.60517 9.72899 6.44923 9.53056 6.32113 9.4115C5.87002 8.99764 5.94242 9.00898 3.42511 9.00898C1.24195 9.00898 1.15841 9.01464 0.913362 9.12803C0.590344 9.28111 0.300741 9.57591 0.133663 9.92175L0 10.1995V16.2658V22.332L0.15594 22.6552C0.323018 23.001 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68624 23.5169 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6495C6.7444 22.5191 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62681 23.2618 10.2753 23.7494 11.5952 23.9195C12.2079 23.9988 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9988 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5745C22.305 20.5065 22.3662 20.4441 22.7115 20.2741C23.3631 19.9452 23.8588 19.2649 23.9758 18.5392C24.076 17.9156 23.8588 17.1672 23.4467 16.7023L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25276 22.1435 8.92393C21.9597 8.88992 20.5005 8.86724 18.4287 8.86724C15.7276 8.86724 15.0092 8.85023 15.0092 8.79354C15.0092 8.75952 15.1819 8.06219 15.3935 7.25146C15.9059 5.27852 15.9226 5.20481 15.917 4.38842C15.9114 3.82715 15.8836 3.56636 15.7722 3.12982C15.5104 2.10933 14.9368 1.16254 14.2685 0.652292C13.6392 0.170394 12.7815 -0.0903978 12.1744 0.0286594ZM13.0989 1.28159C14.0012 1.62176 14.6583 2.6876 14.8087 4.0766C14.8755 4.63787 14.7586 5.28419 14.2239 7.30816C13.9455 8.36833 13.7171 9.33213 13.7116 9.44552C13.706 9.60993 13.7394 9.69497 13.8564 9.81403L14.0067 9.97277L18.0333 10.0011L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7756 22.305 12.2122C22.0599 12.3482 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7394 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5161L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5174C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8157L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0708 22.6336 17.4677C23.0902 18.0346 22.8842 18.9417 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3726 19.1583 19.4407C18.8186 19.6107 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3682 21.6199 22.5588 20.7623 22.8139C20.6119 22.8593 19.2697 22.8706 16.1231 22.8536C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V16.2998V11.5545L7.43499 11.084C8.69365 10.1315 9.62372 9.01464 10.2976 7.67667C10.9325 6.41239 11.3056 5.16513 11.6621 3.14116C11.9294 1.6331 12.0631 1.26459 12.3916 1.13986C12.503 1.10017 12.7425 1.14553 13.0989 1.28159ZM5.56371 10.2336L5.70851 10.347V16.2658V22.1846L5.56371 22.298C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.2698 22.281L1.11386 22.145V16.2658V10.3866L1.2698 10.2506L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                            fill="#2295F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_46">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {thumbs[index] && <span className="namepop">Thanks</span>}
                  <span className="figures figures-size">
                    {interactions[i].interactions.thanks !== undefined && interactions[i].interactions.thanks !== null && !isNaN(interactions[i].interactions.thanks)
                      ? NumberFormat(interactions[i].interactions.thanks)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Helpful"
                      );
                      handleClickin(event);
                      handleHelpfulClick(index);
                    }}
                  >
                    {help[index] ? (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_106_7)">
                          <path
                            d="M0.5 14L2.5 16L2 17L9.5 23.5C10 23.1667 11.3 22.4 12.5 22C13.7 21.6 16.3333 19.8333 17.5 19C19 17.8333 22.2 15.3 23 14.5C23.8 13.7 23.3333 12.5 23 12C22.3333 12 21.2 11.8 22 11C22.8 10.2 22.3333 8.99999 22 8.49999C21.5 8.33332 20.6 7.79999 21 6.99999C21.8 4.99999 20 4.49997 19 4.49996C19.1667 4.16664 19.4 3.29999 19 2.49999C18.5 1.49999 17.5 1.49999 16 1.99999C15.6 1.09673e-05 13.8333 0.499999 13 0.99999L7.5 5.99999C7.16667 5.99998 6.4 5.69996 6 4.49996C5.6 2.49996 3.83333 3.3333 3 3.99996C2.66667 6.16663 2 10.7 2 11.5C2 12.3 1 13.5 0.5 14Z"
                            fill="#4EAF51"
                          />
                          <path
                            d="M13.6079 0.0377471C12.989 0.150247 12.9625 0.168997 9.74081 3.00962C7.25441 5.20806 6.71481 5.66275 6.73597 5.54556C6.92113 4.53775 6.71481 3.87212 6.05882 3.32837C5.57742 2.93462 5.27058 2.8315 4.54583 2.8315C3.83694 2.8315 3.51424 2.93462 3.05928 3.30493C2.71012 3.59556 2.51439 3.85806 2.398 4.20025C2.35039 4.3315 2.20226 5.70025 2.03298 7.53775C1.87427 9.25337 1.72086 10.7909 1.68911 10.9596C1.5357 11.7846 1.11777 12.5346 0.419466 13.2331C0.0121201 13.6409 -0.0725232 13.894 0.0544417 14.3112C0.102054 14.4612 0.297791 14.6627 1.03313 15.3237L1.95363 16.144L1.81608 16.2612C1.51983 16.5049 1.38757 16.8799 1.4828 17.2221C1.54099 17.4424 1.6997 17.5877 5.09601 20.6112C7.51892 22.7674 8.71451 23.794 8.85734 23.8549C9.30701 24.0424 9.70907 23.9393 10.2645 23.4987C10.8465 23.0346 11.2274 22.8471 12.3383 22.4674C14.1264 21.8627 15.9515 20.8737 17.8295 19.4862C18.7289 18.8252 23.4583 14.6487 23.6858 14.3206C23.9397 13.9502 24.0508 13.4346 23.9715 13.0174C23.818 12.2206 23.1832 11.5877 22.3315 11.3862L22.1093 11.3299L22.4056 11.0159C22.7706 10.6362 22.9293 10.3409 23.0086 9.90493C23.1568 9.09868 22.6542 8.2315 21.8289 7.86587C21.6491 7.78618 21.4163 7.71118 21.3052 7.69712L21.1042 7.66431L21.2629 7.49087C21.6385 7.069 21.8131 6.48306 21.7284 5.92993C21.612 5.16118 20.8873 4.47212 20.0144 4.29868C19.7816 4.25181 19.734 4.22368 19.7605 4.16743C20.0038 3.67056 20.062 3.12212 19.9139 2.67681C19.7287 2.12368 19.1732 1.61275 18.5173 1.39243C17.9195 1.19087 17.0783 1.27993 16.5281 1.60806C16.4223 1.67368 16.3324 1.72525 16.3218 1.72525C16.3112 1.72525 16.2901 1.64556 16.2689 1.54712C16.1896 1.08306 15.6553 0.46431 15.1368 0.229935C14.666 0.0189971 14.1211 -0.0513154 13.6079 0.0377471ZM14.6819 0.918997C15.158 1.13462 15.4119 1.50962 15.4172 1.98306C15.4172 2.25493 15.3907 2.35337 15.2691 2.55025C15.1633 2.71431 14.1052 3.67993 11.6241 5.87837C8.27013 8.84556 8.13258 8.95806 8.15903 8.77993C8.24368 8.25493 8.25955 7.58462 8.19607 7.34556C8.10084 6.994 7.9104 6.67056 7.64059 6.41743L7.40783 6.19712L10.328 3.61431C13.0366 1.219 13.3858 0.93306 13.7508 0.829935C13.9624 0.768997 14.4544 0.815872 14.6819 0.918997ZM18.1469 2.12837C18.3638 2.18462 18.4961 2.25962 18.7077 2.45181C18.9987 2.719 19.0939 2.91587 19.0939 3.26743C19.0939 3.67056 18.9987 3.82525 18.4379 4.34087L17.9089 4.82368L17.8401 4.58462C17.6497 3.919 17.073 3.394 16.3165 3.20181L16.015 3.12212L16.4276 2.74712C16.9408 2.28775 17.0889 2.18931 17.3957 2.119C17.7237 2.03931 17.8084 2.03931 18.1469 2.12837ZM4.97962 3.6565C5.26 3.7315 5.67793 4.069 5.78902 4.31275C5.88954 4.52837 5.9107 4.95025 5.84193 5.49868L5.81018 5.794L5.56154 5.82212C4.78388 5.91587 4.00622 6.56743 3.81049 7.30806C3.77875 7.42056 3.62004 8.93931 3.46133 10.6784C3.25502 12.8956 3.13863 13.9549 3.06457 14.2315C2.96934 14.5924 2.562 15.4596 2.48794 15.4596C2.42445 15.4596 0.895584 14.0721 0.895584 14.0159C0.895584 13.9784 1.01726 13.8331 1.16538 13.6877C1.87956 12.994 2.41387 12.0143 2.58316 11.0768C2.6149 10.894 2.77361 9.34243 2.93231 7.62212C3.11747 5.57368 3.24443 4.43931 3.29205 4.33618C3.55656 3.77837 4.30248 3.47368 4.97962 3.6565ZM16.2901 4.02212C16.7609 4.23306 17.0307 4.61743 17.0307 5.07681C17.0307 5.59243 17.0519 5.569 14.1475 8.14712C12.6822 9.45025 11.4548 10.5706 11.4284 10.6409C11.3279 10.8846 11.5395 11.1471 11.841 11.1471C12.0209 11.1471 12.206 10.9877 15.3643 8.20337C17.5703 6.25337 18.7712 5.22681 18.9087 5.16587C19.2156 5.03462 19.8398 5.044 20.1308 5.17993C20.4111 5.31118 20.6968 5.6065 20.7762 5.84556C20.8714 6.12212 20.8502 6.50181 20.7286 6.74087C20.6492 6.90025 19.8398 7.64556 17.2952 9.90493C14.1105 12.7315 13.9624 12.8674 13.9624 13.0315C13.9624 13.2612 14.2216 13.4674 14.4597 13.4252C14.5866 13.4018 15.2373 12.8534 17.2952 11.0346C19.1468 9.39868 20.0408 8.63931 20.2048 8.56431C20.5487 8.40962 21.0407 8.419 21.4004 8.58306C21.866 8.794 22.1199 9.14556 22.1252 9.60025C22.1358 10.1206 22.2204 10.0315 19.279 12.6471C17.3534 14.3534 16.5493 15.1034 16.5228 15.1971C16.4488 15.469 16.7556 15.7409 17.0625 15.6752C17.1683 15.6518 17.8084 15.1221 19.1468 13.9409C21.2364 12.1034 21.1994 12.1268 21.7707 12.1315C22.2839 12.1362 22.6859 12.3518 22.9293 12.7502C23.1303 13.0737 23.1409 13.5002 22.9663 13.8237C22.8817 13.9737 22.1887 14.6206 20.4323 16.1674C19.0992 17.3393 17.7396 18.5065 17.4063 18.7549C15.5653 20.1471 13.8037 21.1081 11.878 21.7737C11.476 21.9096 11.0263 22.0784 10.8729 22.1487C10.4761 22.3268 9.89422 22.6924 9.62442 22.9362C9.49746 23.0534 9.35462 23.1471 9.30701 23.1471C9.26469 23.1471 7.66705 21.769 5.76786 20.0815C2.54084 17.2221 2.31336 17.0065 2.38213 16.9221C2.42445 16.8752 2.6149 16.6596 2.80535 16.4487C3.15979 16.0596 3.55656 15.4456 3.747 14.9909C4.00622 14.3721 4.06442 13.9784 4.36067 10.7487C4.52466 8.99556 4.68337 7.4815 4.71511 7.38306C4.78917 7.15806 5.13304 6.81118 5.38697 6.69868C6.00592 6.41743 6.75184 6.60962 7.13803 7.14868C7.34963 7.444 7.37079 7.62212 7.27557 8.61587C7.14332 9.97993 7.15919 10.1018 7.49247 10.2518C7.80988 10.3971 7.68292 10.4956 11.4495 7.16743C14.7295 4.26587 15.0151 4.02212 15.2585 3.9565C15.5812 3.86743 16.0044 3.89556 16.2901 4.02212Z"
                            fill="#90EE90"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_106_7">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_4_40)">
                          <path
                            d="M13.6112 0.0937247C12.9923 0.206225 12.9658 0.224975 9.7441 3.0656C7.25771 5.26404 6.71811 5.71872 6.73927 5.60154C6.92442 4.59372 6.71811 3.9281 6.06212 3.38435C5.58071 2.9906 5.27388 2.88747 4.54912 2.88747C3.84023 2.88747 3.51753 2.9906 3.06257 3.36091C2.71342 3.65154 2.51768 3.91404 2.4013 4.25622C2.35369 4.38747 2.20556 5.75622 2.03627 7.59372C1.87757 9.30935 1.72415 10.8468 1.69241 11.0156C1.53899 11.8406 1.12107 12.5906 0.422762 13.289C0.015416 13.6968 -0.0692273 13.95 0.0577376 14.3672C0.105349 14.5172 0.301087 14.7187 1.03643 15.3797L1.95692 16.2L1.81938 16.3172C1.52312 16.5609 1.39087 16.9359 1.48609 17.2781C1.54429 17.4984 1.70299 17.6437 5.0993 20.6672C7.52222 22.8234 8.7178 23.85 8.86064 23.9109C9.31031 24.0984 9.71236 23.9953 10.2678 23.5547C10.8498 23.0906 11.2306 22.9031 12.3416 22.5234C14.1297 21.9187 15.9548 20.9297 17.8328 19.5422C18.7322 18.8812 23.4616 14.7047 23.6891 14.3765C23.943 14.0062 24.0541 13.4906 23.9748 13.0734C23.8213 12.2765 23.1865 11.6437 22.3348 11.4422L22.1126 11.3859L22.4089 11.0718C22.7739 10.6922 22.9326 10.3968 23.0119 9.96091C23.1601 9.15466 22.6575 8.28747 21.8322 7.92185C21.6524 7.84216 21.4196 7.76716 21.3085 7.7531L21.1075 7.72029L21.2662 7.54685C21.6418 7.12497 21.8163 6.53904 21.7317 5.98591C21.6153 5.21716 20.8906 4.5281 20.0177 4.35466C19.7849 4.30779 19.7373 4.27966 19.7637 4.22341C20.0071 3.72654 20.0653 3.1781 19.9172 2.73279C19.732 2.17966 19.1765 1.66872 18.5206 1.44841C17.9228 1.24685 17.0816 1.33591 16.5314 1.66404C16.4256 1.72966 16.3357 1.78122 16.3251 1.78122C16.3145 1.78122 16.2934 1.70154 16.2722 1.6031C16.1929 1.13904 15.6586 0.520287 15.1401 0.285912C14.6693 0.0749747 14.1244 0.00466223 13.6112 0.0937247ZM14.6852 0.974975C15.1613 1.1906 15.4152 1.5656 15.4205 2.03904C15.4205 2.31091 15.394 2.40935 15.2724 2.60622C15.1666 2.77029 14.1085 3.73591 11.6274 5.93435C8.27343 8.90154 8.13588 9.01404 8.16233 8.83591C8.24697 8.31091 8.26284 7.6406 8.19936 7.40154C8.10414 7.04997 7.91369 6.72654 7.64389 6.47341L7.41112 6.2531L10.3313 3.67029C13.0399 1.27497 13.3891 0.989037 13.7541 0.885912C13.9657 0.824975 14.4577 0.87185 14.6852 0.974975ZM18.1502 2.18435C18.3671 2.2406 18.4994 2.3156 18.711 2.50779C19.002 2.77497 19.0972 2.97185 19.0972 3.32341C19.0972 3.72654 19.002 3.88122 18.4412 4.39685L17.9122 4.87966L17.8434 4.6406C17.653 3.97497 17.0763 3.44997 16.3198 3.25779L16.0183 3.1781L16.4309 2.8031C16.9441 2.34372 17.0922 2.24529 17.399 2.17497C17.727 2.09529 17.8117 2.09529 18.1502 2.18435ZM4.98292 3.71247C5.2633 3.78747 5.68123 4.12497 5.79232 4.36872C5.89283 4.58435 5.91399 5.00622 5.84522 5.55466L5.81348 5.84997L5.56484 5.8781C4.78718 5.97185 4.00952 6.62341 3.81378 7.36404C3.78204 7.47654 3.62334 8.99529 3.46463 10.7343C3.25831 12.9515 3.14193 14.0109 3.06786 14.2875C2.97264 14.6484 2.56529 15.5156 2.49123 15.5156C2.42775 15.5156 0.89888 14.1281 0.89888 14.0718C0.89888 14.0343 1.02055 13.889 1.16868 13.7437C1.88286 13.05 2.41717 12.0703 2.58646 11.1328C2.6182 10.95 2.7769 9.39841 2.93561 7.6781C3.12077 5.62966 3.24773 4.49529 3.29534 4.39216C3.55985 3.83435 4.30577 3.52966 4.98292 3.71247ZM16.2934 4.0781C16.7642 4.28904 17.034 4.67341 17.034 5.13279C17.034 5.64841 17.0552 5.62497 14.1508 8.2031C12.6855 9.50622 11.4581 10.6265 11.4317 10.6968C11.3312 10.9406 11.5428 11.2031 11.8443 11.2031C12.0242 11.2031 12.2093 11.0437 15.3676 8.25935C17.5736 6.30935 18.7745 5.28279 18.912 5.22185C19.2189 5.0906 19.8431 5.09997 20.1341 5.23591C20.4144 5.36716 20.7001 5.66247 20.7795 5.90154C20.8747 6.1781 20.8535 6.55779 20.7319 6.79685C20.6525 6.95622 19.8431 7.70154 17.2985 9.96091C14.1138 12.7875 13.9657 12.9234 13.9657 13.0875C13.9657 13.3172 14.2249 13.5234 14.463 13.4812C14.5899 13.4578 15.2406 12.9093 17.2985 11.0906C19.1501 9.45466 20.0441 8.69529 20.2081 8.62029C20.552 8.4656 21.044 8.47497 21.4037 8.63904C21.8693 8.84997 22.1232 9.20154 22.1285 9.65622C22.1391 10.1765 22.2237 10.0875 19.2823 12.7031C17.3567 14.4093 16.5526 15.1593 16.5261 15.2531C16.4521 15.525 16.7589 15.7968 17.0657 15.7312C17.1715 15.7078 17.8117 15.1781 19.1501 13.9968C21.2397 12.1593 21.2027 12.1828 21.774 12.1875C22.2872 12.1922 22.6892 12.4078 22.9326 12.8062C23.1336 13.1297 23.1442 13.5562 22.9696 13.8797C22.885 14.0297 22.192 14.6765 20.4356 16.2234C19.1025 17.3953 17.7429 18.5625 17.4096 18.8109C15.5686 20.2031 13.807 21.164 11.8813 21.8297C11.4793 21.9656 11.0296 22.1343 10.8762 22.2047C10.4794 22.3828 9.89752 22.7484 9.62772 22.9922C9.50075 23.1093 9.35792 23.2031 9.31031 23.2031C9.26798 23.2031 7.67034 21.825 5.77116 20.1375C2.54413 17.2781 2.31666 17.0625 2.38543 16.9781C2.42775 16.9312 2.6182 16.7156 2.80864 16.5047C3.16309 16.1156 3.55985 15.5015 3.7503 15.0468C4.00952 14.4281 4.06771 14.0343 4.36396 10.8047C4.52796 9.05154 4.68667 7.53747 4.71841 7.43904C4.79247 7.21404 5.13633 6.86716 5.39026 6.75466C6.00922 6.47341 6.75514 6.6656 7.14132 7.20466C7.35293 7.49997 7.37409 7.6781 7.27887 8.67185C7.14661 10.0359 7.16248 10.1578 7.49577 10.3078C7.81318 10.4531 7.68621 10.5515 11.4528 7.22341C14.7328 4.32185 15.0184 4.0781 15.2618 4.01247C15.5845 3.92341 16.0077 3.95154 16.2934 4.0781Z"
                            fill="#4EAF51"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_40">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {help[index] && <span className="namepop">Helpful</span>}
                  <span className="figures figures-size">
                    {interactions[i].interactions.helpful !== undefined && interactions[i].interactions.helpful !== null
                      ? NumberFormat(interactions[i].interactions.helpful)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Share"
                      );
                      handleClickin(event);
                      handleShareClick(index);
                      openShareModal();
                    }}
                  >
                    {share[index] ? (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_110_30)">
                          <rect
                            x="1"
                            y="9"
                            width="22"
                            height="15"
                            fill="black"
                          />
                          <path
                            d="M0 10C0 9.44772 0.447715 9 1 9V23H0V10Z"
                            fill="black"
                          />
                          <path
                            d="M23 9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                            fill="black"
                          />
                          <path
                            d="M24 23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23H24Z"
                            fill="black"
                          />
                          <path d="M6 9V10L1 10L1 9H6Z" fill="black" />
                          <path d="M23 9V10L18 10V9L23 9Z" fill="black" />
                          <rect
                            x="11"
                            y="9"
                            width="2"
                            height="7"
                            fill="white"
                          />
                          <path
                            d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_110_30">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_4_64)">
                          <path
                            d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                            fill="black"
                          />
                          <path
                            d="M0 10C0 9.44772 0.447715 9 1 9V9V23H0V10Z"
                            fill="black"
                          />
                          <path
                            d="M23 9V9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                            fill="black"
                          />
                          <path
                            d="M24 23V23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23V23L24 23Z"
                            fill="black"
                          />
                          <rect
                            x="6"
                            y="9"
                            width="1"
                            height="5"
                            transform="rotate(90 6 9)"
                            fill="black"
                          />
                          <rect
                            x="23"
                            y="9"
                            width="1"
                            height="5"
                            transform="rotate(90 23 9)"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_64">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {share[index] && <span className="namepop">Share</span>}
                  <>
                    {isShareOption && (
                      <div className="modal sharemodal">
                        <div className="modal-content share-card">
                          <span
                            className="Close shareclose"
                            onClick={closeModalshare}
                          >
                            &times;
                          </span>
                          <div className="mb-3.5">
                            <h1 className="ml-2 font-bold text-base">
                              Share With:
                            </h1>
                          </div>
                          <div className="d-flex contents ml-2">
                            <FacebookShareButton
                              url={shareCard(index)}
                              className="ml-2"
                            >
                              <FacebookIcon></FacebookIcon>
                            </FacebookShareButton>

                            <TwitterShareButton
                              url={shareCard(index)}
                              className="ml-2"
                            >
                              <TwitterIcon></TwitterIcon>
                            </TwitterShareButton>
                            <WhatsappShareButton
                              url={window.location.href}
                              className="ml-2"
                            >
                              <WhatsappIcon></WhatsappIcon>
                            </WhatsappShareButton>
                            <LinkedinShareButton
                              url={window.location.href}
                              className="ml-2"
                            >
                              <LinkedinIcon></LinkedinIcon>
                            </LinkedinShareButton>
                            <EmailShareButton
                              className="ml-2"
                              url={shareCard(index)}
                            >
                              <EmailIcon></EmailIcon>
                            </EmailShareButton>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  <span className="figures figures-size">
                    {interactions[i].interactions.shares !== undefined && interactions[i].interactions.shares !== null
                      ? NumberFormat(interactions[i].interactions.shares)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1 sppot">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Support"
                      );
                      handleClickin(event);
                      handleSupportClick(index);
                      openSupportModel();
                    }}
                  >
                    {support[index] ? (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_110_26)">
                          <path
                            d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
                            fill="#FCD12A"
                          />
                          <path
                            d="M11.9998 0C5.38038 0 0 5.38038 0 11.9998C0 18.6192 5.38038 24 11.9998 24C18.6192 24 24 18.6196 24 11.9998C24 5.37994 18.6196 0 11.9998 0ZM11.9998 1.33327C17.8989 1.33327 22.6666 6.10099 22.6666 12.0001C22.6666 17.8992 17.8989 22.6669 11.9998 22.6669C6.10112 22.6669 1.33297 17.8992 1.33297 12.0001C1.33297 6.10143 6.10068 1.33327 11.9998 1.33327Z"
                            fill="#FCD12A"
                          />
                          <path
                            d="M12.0136 6.00004C10.3356 6.01744 8.8123 7.10205 8.08658 8.71894C7.9944 8.88159 7.97493 9.07526 8.03248 9.25306C8.0902 9.43069 8.21976 9.57612 8.38965 9.65382C8.55954 9.73136 8.75441 9.73411 8.92637 9.6614C9.0985 9.58869 9.2322 9.44706 9.29492 9.27097C9.82286 8.0945 10.9304 7.34933 12.024 7.33345H12.0345C13.0021 7.34275 13.7444 7.62981 14.2428 8.08348C14.7432 8.53885 15.024 9.16829 15.024 10.0001C15.024 10.4326 14.88 10.7689 14.5969 11.1459C14.3138 11.5229 13.8855 11.9074 13.4303 12.3128C12.5198 13.1234 11.3894 14.0954 11.3573 15.6461C11.3529 15.823 11.419 15.9946 11.5412 16.1228C11.6633 16.251 11.8313 16.3253 12.0085 16.3294C12.1854 16.3335 12.3569 16.2672 12.4849 16.1449C12.6127 16.0225 12.6868 15.8544 12.6908 15.6772C12.7092 14.7795 13.4055 14.1233 14.3158 13.3126C14.771 12.9074 15.2631 12.4761 15.6595 11.9482C16.056 11.42 16.3575 10.7675 16.3575 10.0001C16.3575 8.84316 15.9188 7.804 15.1387 7.09376C14.3585 6.3837 13.2623 6.00895 12.024 6L12.0136 6.00004ZM11.6907 17.3338C11.506 17.3338 11.3573 17.4825 11.3573 17.667V18.3338C11.3573 18.5185 11.506 18.667 11.6907 18.667H12.3574C12.5421 18.667 12.6908 18.5185 12.6908 18.3338V17.667C12.6908 17.4825 12.5421 17.3338 12.3574 17.3338H11.6907Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_110_26">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="IconSize"
                      >
                        <g clip-path="url(#clip0_4_67)">
                          <circle cx="12" cy="12" r="11.5" stroke="black" />
                          <path
                            d="M11.208 14.3426V14.2744C11.2156 13.551 11.2913 12.9752 11.4353 12.5472C11.5792 12.1191 11.7837 11.7726 12.0489 11.5074C12.314 11.2423 12.6322 10.9979 13.0034 10.7744C13.2269 10.6381 13.4277 10.4771 13.6057 10.2915C13.7837 10.1021 13.9239 9.8843 14.0262 9.63808C14.1322 9.39187 14.1853 9.11914 14.1853 8.8199C14.1853 8.44869 14.0981 8.12672 13.9239 7.85399C13.7497 7.58127 13.5167 7.37104 13.225 7.22331C12.9334 7.07558 12.6095 7.00172 12.2534 7.00172C11.9428 7.00172 11.6436 7.06611 11.3557 7.1949C11.0678 7.32369 10.8273 7.52634 10.6341 7.80286C10.4409 8.07937 10.3292 8.44111 10.2989 8.88808H8.86708C8.89738 8.24414 9.06405 7.69301 9.36708 7.23467C9.67389 6.77634 10.0773 6.42596 10.5773 6.18354C11.0811 5.94111 11.6398 5.8199 12.2534 5.8199C12.9201 5.8199 13.4997 5.95248 13.9921 6.21763C14.4883 6.48278 14.8709 6.84642 15.1398 7.30854C15.4125 7.77066 15.5489 8.29717 15.5489 8.88808C15.5489 9.30475 15.4845 9.68164 15.3557 10.0188C15.2307 10.3559 15.0489 10.657 14.8103 10.9222C14.5754 11.1873 14.2913 11.4222 13.958 11.6267C13.6247 11.8351 13.3576 12.0548 13.1568 12.2858C12.9561 12.5131 12.8103 12.7839 12.7193 13.0983C12.6284 13.4127 12.5792 13.8048 12.5716 14.2744V14.3426H11.208ZM11.9353 17.7063C11.655 17.7063 11.4144 17.6059 11.2137 17.4051C11.0129 17.2044 10.9125 16.9638 10.9125 16.6835C10.9125 16.4032 11.0129 16.1627 11.2137 15.9619C11.4144 15.7612 11.655 15.6608 11.9353 15.6608C12.2156 15.6608 12.4561 15.7612 12.6568 15.9619C12.8576 16.1627 12.958 16.4032 12.958 16.6835C12.958 16.8691 12.9106 17.0396 12.8159 17.1949C12.725 17.3502 12.6019 17.4752 12.4466 17.5699C12.2951 17.6608 12.1247 17.7063 11.9353 17.7063Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_67">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {support[index] && <span className="namepop">Support</span>}
                  <>
                    {showModalsupport && (
                      <div className="modal sharemodal">
                        <div className="modal-content">
                          <span
                            className="Close shareclose closesupport"
                            onClick={closeModalsupport}
                          >
                            &times;
                          </span>
                          <h2 className="flex justify-center font-bold">
                            Contact Us
                          </h2>
                          <p className="mt-2 mb-4 font-medium">
                            Have a question? Select an option below to contct us
                          </p>
                          <div className="flex justify-around items-center ">
                            <button
                              onClick={() => handlePhoneClick("123-456-7890")}
                              className="flex items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-telephone-fill"
                                viewBox="0 0 16 16"
                                style={{ fill: logo.Primary_Color__c }}
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                                />
                              </svg>
                              <span className="ml-1.5">Call</span>
                            </button>
                            <button
                              onClick={() =>
                                handleEmailClick("example@example.com")
                              }
                              className="flex items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-envelope-fill"
                                viewBox="0 0 16 16"
                                style={{ fill: logo.Primary_Color__c }}
                              >
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                              </svg>
                              <span className="ml-1.5">Email</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  <span className="figures figures-size">
                    {interactions[i].interactions.support !== undefined && interactions[i].interactions.support !== null
                      ? NumberFormat(interactions[i].interactions.support)
                      : 0}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-center flex justify-center ">
              <span className="figures figures-size">
                {interactions[i].interactions.views}{" "}
                {interactions[i].interactions.views === 0 ||
                  interactions[i].interactions.views === 1
                  ? "View"
                  : "Views"}
              </span>
            </div>
          </>
        );
      }
    }
    return (
      <>
        <div className="flex flex-col flex-row">
          <div className="flex justify-center gap-5">
            <div className=" text-sm mb-2 flex gap-1">
              <button
                id="like-button"
                onClick={(event) => {
                  postData(newschoolId, post.title, "Like");
                  handleClickin(event);
                  handleLikeClick(i);
                }}
              >
                {liked[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="likesanimation"
                  >
                    <g clip-path="url(#clip0_107_13)">
                      <path
                        d="M1.5 9.5C2.3 14.3 8.83333 20.1667 12 22.5L16 19.5C17.6666 18 21.4 13.7 23 8.5C23.4 0.900004 17.5 0.666671 14.5 1.5C14.1667 1.66667 13.1 2.3 11.5 3.5C6.5 -1.5 0.5 3.5 1.5 9.5Z"
                        fill="#F54438"
                      />
                      <path
                        d="M6.2812 0.0143438C5.07183 0.191295 4.08745 0.582733 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.4972C23.3296 3.24773 21.2531 0.834754 18.4031 0.132311C17.7703 -0.0231918 16.4578 -0.0339152 15.8203 0.110863C14.5312 0.40042 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765046 9.05152 0.293177 8.17027 0.116226C7.76245 0.0304316 6.59995 -0.0285535 6.2812 0.0143438ZM7.61714 1.75705C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56146 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56146 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829393 20.6578 2.13776 21.9609 5.24781C23.1796 8.15947 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75705Z"
                        fill="#F54438"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_107_13">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"

                  >
                    <g clip-path="url(#clip0_4_37)">
                      <path
                        d="M6.2812 0.0143425C5.07183 0.191294 4.08745 0.582731 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.49719C23.3296 3.24773 21.2531 0.834753 18.4031 0.13231C17.7703 -0.0231931 16.4578 -0.0339165 15.8203 0.110862C14.5312 0.400418 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765044 9.05152 0.293176 8.17027 0.116225C7.76245 0.0304303 6.59995 -0.0285548 6.2812 0.0143425ZM7.61714 1.75704C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56145 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56145 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829392 20.6578 2.13776 21.9609 5.24781C23.1796 8.15946 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75704Z"
                        fill="#F54438"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_37">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <span className="figures figures-size">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                id="share-button"
                onClick={(event) => {
                  postData(newschoolId, post.title, "Thanks");
                  handleClickin(event);
                  handleThumbsClick(i);
                }}
              >
                {thumbs[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"

                  >
                    <g clip-path="url(#clip0_107_16)">
                      <path
                        d="M0.5 21C0.5 23.4 2.83333 23.3334 4 23L6 22.5L7 22L12.5 23.5H21C22.2 23.5 22.1667 21.1667 22 20C22.5 19.6667 23.5 18.8 23.5 18C23.5 17.2 22.5 16.6667 22 16.5C22.3333 16.3334 23 15.7 23 14.5C23 13.3 22 13 21.5 13C22 13 23.1 12.7 23.5 11.5C23.9 10.3 22.3333 9.66669 21.5 9.50003H14.5L15 8.00002C15.1667 7.00003 15.3 4.40006 14.5 2.00006C13.5 -0.999944 11 1.00006 11 3.50006C11 6.00006 8 9.50003 8 10C8 10.4 7 10.5 6.5 10.5001C6.23238 10.3334 5.65772 9.90003 5.5 9.50003C5.34228 9.10003 3.43428 9.33336 2.5 9.50003L0.5 10V21Z"
                        fill="#2295F1"
                      />
                      <path
                        d="M12.1744 0.0286915C11.3391 0.193104 10.9325 0.862092 10.6373 2.57425C10.1305 5.52233 9.55688 7.08141 8.47087 8.49309C7.98635 9.12239 6.87806 10.1939 6.80009 10.1089C6.78895 10.0975 6.72769 9.98414 6.66643 9.85375C6.60517 9.72902 6.44923 9.53059 6.32113 9.41153C5.87002 8.99767 5.94242 9.00901 3.42511 9.00901C1.24195 9.00901 1.15841 9.01468 0.913362 9.12806C0.590344 9.28114 0.300741 9.57595 0.133663 9.92178L0 10.1996V22.3321L0.15594 22.6552C0.323018 23.0011 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68623 23.517 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6496C6.7444 22.5192 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62682 23.2619 10.2753 23.7494 11.5952 23.9195C12.2079 23.9989 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9989 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5746C22.305 20.5065 22.3662 20.4442 22.7115 20.2741C23.3631 19.9453 23.8588 19.2649 23.9758 18.5393C24.076 17.9156 23.8588 17.1673 23.4467 16.7024L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25279 22.1435 8.92397C21.9597 8.88995 20.5005 8.86727 18.4287 8.86727C15.7276 8.86727 15.0092 8.85026 15.0092 8.79357C15.0092 8.75955 15.1819 8.06222 15.3935 7.25149C15.9059 5.27855 15.9226 5.20485 15.917 4.38845C15.9114 3.82718 15.8836 3.56639 15.7722 3.12985C15.5104 2.10936 14.9368 1.16257 14.2685 0.652324C13.6392 0.170426 12.7815 -0.0903657 12.1744 0.0286915ZM13.0989 1.28163C14.0012 1.62179 14.6583 2.68764 14.8087 4.07664C14.8755 4.63791 14.7586 5.28422 14.2239 7.30819C13.9455 8.36836 13.7171 9.33216 13.7116 9.44555C13.706 9.60996 13.7394 9.695 13.8564 9.81406L14.0067 9.9728L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7757 22.305 12.2122C22.0599 12.3483 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7395 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5162L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5175C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8158L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0709 22.6336 17.4677C23.0902 18.0347 22.8842 18.9418 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3727 19.1583 19.4407C18.8186 19.6108 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3683 21.6199 22.5589 20.7623 22.814C20.6119 22.8593 19.2697 22.8707 16.1231 22.8537C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V11.5546L7.43499 11.084C8.69365 10.1315 9.62372 9.01468 10.2976 7.6767C10.9325 6.41243 11.3056 5.16516 11.6621 3.14119C11.9294 1.63313 12.0631 1.26462 12.3916 1.13989C12.503 1.10021 12.7425 1.14556 13.0989 1.28163ZM5.56371 10.2336L5.70851 10.347V22.1847L5.56371 22.2981C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.11386 22.145V10.3867L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                        fill="#2295F1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_107_16">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_46)">
                      <path
                        d="M12.1744 0.0286594C11.3391 0.193072 10.9325 0.86206 10.6373 2.57422C10.1305 5.5223 9.55688 7.08138 8.47088 8.49306C7.98635 9.12236 6.87806 10.1939 6.80009 10.1088C6.78895 10.0975 6.72769 9.98411 6.66643 9.85371C6.60517 9.72899 6.44923 9.53056 6.32113 9.4115C5.87002 8.99764 5.94242 9.00898 3.42511 9.00898C1.24195 9.00898 1.15841 9.01464 0.913362 9.12803C0.590344 9.28111 0.300741 9.57591 0.133663 9.92175L0 10.1995V16.2658V22.332L0.15594 22.6552C0.323018 23.001 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68624 23.5169 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6495C6.7444 22.5191 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62681 23.2618 10.2753 23.7494 11.5952 23.9195C12.2079 23.9988 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9988 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5745C22.305 20.5065 22.3662 20.4441 22.7115 20.2741C23.3631 19.9452 23.8588 19.2649 23.9758 18.5392C24.076 17.9156 23.8588 17.1672 23.4467 16.7023L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25276 22.1435 8.92393C21.9597 8.88992 20.5005 8.86724 18.4287 8.86724C15.7276 8.86724 15.0092 8.85023 15.0092 8.79354C15.0092 8.75952 15.1819 8.06219 15.3935 7.25146C15.9059 5.27852 15.9226 5.20481 15.917 4.38842C15.9114 3.82715 15.8836 3.56636 15.7722 3.12982C15.5104 2.10933 14.9368 1.16254 14.2685 0.652292C13.6392 0.170394 12.7815 -0.0903978 12.1744 0.0286594ZM13.0989 1.28159C14.0012 1.62176 14.6583 2.6876 14.8087 4.0766C14.8755 4.63787 14.7586 5.28419 14.2239 7.30816C13.9455 8.36833 13.7171 9.33213 13.7116 9.44552C13.706 9.60993 13.7394 9.69497 13.8564 9.81403L14.0067 9.97277L18.0333 10.0011L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7756 22.305 12.2122C22.0599 12.3482 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7394 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5161L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5174C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8157L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0708 22.6336 17.4677C23.0902 18.0346 22.8842 18.9417 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3726 19.1583 19.4407C18.8186 19.6107 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3682 21.6199 22.5588 20.7623 22.8139C20.6119 22.8593 19.2697 22.8706 16.1231 22.8536C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V16.2998V11.5545L7.43499 11.084C8.69365 10.1315 9.62372 9.01464 10.2976 7.67667C10.9325 6.41239 11.3056 5.16513 11.6621 3.14116C11.9294 1.6331 12.0631 1.26459 12.3916 1.13986C12.503 1.10017 12.7425 1.14553 13.0989 1.28159ZM5.56371 10.2336L5.70851 10.347V16.2658V22.1846L5.56371 22.298C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.2698 22.281L1.11386 22.145V16.2658V10.3866L1.2698 10.2506L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                        fill="#2295F1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_46">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <span className="figures figures-size">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Helpful");
                  handleClickin(event);
                  handleHelpfulClick(index);
                }}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4_40)">
                    <path
                      d="M13.6112 0.0937247C12.9923 0.206225 12.9658 0.224975 9.7441 3.0656C7.25771 5.26404 6.71811 5.71872 6.73927 5.60154C6.92442 4.59372 6.71811 3.9281 6.06212 3.38435C5.58071 2.9906 5.27388 2.88747 4.54912 2.88747C3.84023 2.88747 3.51753 2.9906 3.06257 3.36091C2.71342 3.65154 2.51768 3.91404 2.4013 4.25622C2.35369 4.38747 2.20556 5.75622 2.03627 7.59372C1.87757 9.30935 1.72415 10.8468 1.69241 11.0156C1.53899 11.8406 1.12107 12.5906 0.422762 13.289C0.015416 13.6968 -0.0692273 13.95 0.0577376 14.3672C0.105349 14.5172 0.301087 14.7187 1.03643 15.3797L1.95692 16.2L1.81938 16.3172C1.52312 16.5609 1.39087 16.9359 1.48609 17.2781C1.54429 17.4984 1.70299 17.6437 5.0993 20.6672C7.52222 22.8234 8.7178 23.85 8.86064 23.9109C9.31031 24.0984 9.71236 23.9953 10.2678 23.5547C10.8498 23.0906 11.2306 22.9031 12.3416 22.5234C14.1297 21.9187 15.9548 20.9297 17.8328 19.5422C18.7322 18.8812 23.4616 14.7047 23.6891 14.3765C23.943 14.0062 24.0541 13.4906 23.9748 13.0734C23.8213 12.2765 23.1865 11.6437 22.3348 11.4422L22.1126 11.3859L22.4089 11.0718C22.7739 10.6922 22.9326 10.3968 23.0119 9.96091C23.1601 9.15466 22.6575 8.28747 21.8322 7.92185C21.6524 7.84216 21.4196 7.76716 21.3085 7.7531L21.1075 7.72029L21.2662 7.54685C21.6418 7.12497 21.8163 6.53904 21.7317 5.98591C21.6153 5.21716 20.8906 4.5281 20.0177 4.35466C19.7849 4.30779 19.7373 4.27966 19.7637 4.22341C20.0071 3.72654 20.0653 3.1781 19.9172 2.73279C19.732 2.17966 19.1765 1.66872 18.5206 1.44841C17.9228 1.24685 17.0816 1.33591 16.5314 1.66404C16.4256 1.72966 16.3357 1.78122 16.3251 1.78122C16.3145 1.78122 16.2934 1.70154 16.2722 1.6031C16.1929 1.13904 15.6586 0.520287 15.1401 0.285912C14.6693 0.0749747 14.1244 0.00466223 13.6112 0.0937247ZM14.6852 0.974975C15.1613 1.1906 15.4152 1.5656 15.4205 2.03904C15.4205 2.31091 15.394 2.40935 15.2724 2.60622C15.1666 2.77029 14.1085 3.73591 11.6274 5.93435C8.27343 8.90154 8.13588 9.01404 8.16233 8.83591C8.24697 8.31091 8.26284 7.6406 8.19936 7.40154C8.10414 7.04997 7.91369 6.72654 7.64389 6.47341L7.41112 6.2531L10.3313 3.67029C13.0399 1.27497 13.3891 0.989037 13.7541 0.885912C13.9657 0.824975 14.4577 0.87185 14.6852 0.974975ZM18.1502 2.18435C18.3671 2.2406 18.4994 2.3156 18.711 2.50779C19.002 2.77497 19.0972 2.97185 19.0972 3.32341C19.0972 3.72654 19.002 3.88122 18.4412 4.39685L17.9122 4.87966L17.8434 4.6406C17.653 3.97497 17.0763 3.44997 16.3198 3.25779L16.0183 3.1781L16.4309 2.8031C16.9441 2.34372 17.0922 2.24529 17.399 2.17497C17.727 2.09529 17.8117 2.09529 18.1502 2.18435ZM4.98292 3.71247C5.2633 3.78747 5.68123 4.12497 5.79232 4.36872C5.89283 4.58435 5.91399 5.00622 5.84522 5.55466L5.81348 5.84997L5.56484 5.8781C4.78718 5.97185 4.00952 6.62341 3.81378 7.36404C3.78204 7.47654 3.62334 8.99529 3.46463 10.7343C3.25831 12.9515 3.14193 14.0109 3.06786 14.2875C2.97264 14.6484 2.56529 15.5156 2.49123 15.5156C2.42775 15.5156 0.89888 14.1281 0.89888 14.0718C0.89888 14.0343 1.02055 13.889 1.16868 13.7437C1.88286 13.05 2.41717 12.0703 2.58646 11.1328C2.6182 10.95 2.7769 9.39841 2.93561 7.6781C3.12077 5.62966 3.24773 4.49529 3.29534 4.39216C3.55985 3.83435 4.30577 3.52966 4.98292 3.71247ZM16.2934 4.0781C16.7642 4.28904 17.034 4.67341 17.034 5.13279C17.034 5.64841 17.0552 5.62497 14.1508 8.2031C12.6855 9.50622 11.4581 10.6265 11.4317 10.6968C11.3312 10.9406 11.5428 11.2031 11.8443 11.2031C12.0242 11.2031 12.2093 11.0437 15.3676 8.25935C17.5736 6.30935 18.7745 5.28279 18.912 5.22185C19.2189 5.0906 19.8431 5.09997 20.1341 5.23591C20.4144 5.36716 20.7001 5.66247 20.7795 5.90154C20.8747 6.1781 20.8535 6.55779 20.7319 6.79685C20.6525 6.95622 19.8431 7.70154 17.2985 9.96091C14.1138 12.7875 13.9657 12.9234 13.9657 13.0875C13.9657 13.3172 14.2249 13.5234 14.463 13.4812C14.5899 13.4578 15.2406 12.9093 17.2985 11.0906C19.1501 9.45466 20.0441 8.69529 20.2081 8.62029C20.552 8.4656 21.044 8.47497 21.4037 8.63904C21.8693 8.84997 22.1232 9.20154 22.1285 9.65622C22.1391 10.1765 22.2237 10.0875 19.2823 12.7031C17.3567 14.4093 16.5526 15.1593 16.5261 15.2531C16.4521 15.525 16.7589 15.7968 17.0657 15.7312C17.1715 15.7078 17.8117 15.1781 19.1501 13.9968C21.2397 12.1593 21.2027 12.1828 21.774 12.1875C22.2872 12.1922 22.6892 12.4078 22.9326 12.8062C23.1336 13.1297 23.1442 13.5562 22.9696 13.8797C22.885 14.0297 22.192 14.6765 20.4356 16.2234C19.1025 17.3953 17.7429 18.5625 17.4096 18.8109C15.5686 20.2031 13.807 21.164 11.8813 21.8297C11.4793 21.9656 11.0296 22.1343 10.8762 22.2047C10.4794 22.3828 9.89752 22.7484 9.62772 22.9922C9.50075 23.1093 9.35792 23.2031 9.31031 23.2031C9.26798 23.2031 7.67034 21.825 5.77116 20.1375C2.54413 17.2781 2.31666 17.0625 2.38543 16.9781C2.42775 16.9312 2.6182 16.7156 2.80864 16.5047C3.16309 16.1156 3.55985 15.5015 3.7503 15.0468C4.00952 14.4281 4.06771 14.0343 4.36396 10.8047C4.52796 9.05154 4.68667 7.53747 4.71841 7.43904C4.79247 7.21404 5.13633 6.86716 5.39026 6.75466C6.00922 6.47341 6.75514 6.6656 7.14132 7.20466C7.35293 7.49997 7.37409 7.6781 7.27887 8.67185C7.14661 10.0359 7.16248 10.1578 7.49577 10.3078C7.81318 10.4531 7.68621 10.5515 11.4528 7.22341C14.7328 4.32185 15.0184 4.0781 15.2618 4.01247C15.5845 3.92341 16.0077 3.95154 16.2934 4.0781Z"
                      fill="#4EAF51"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_40">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <span className="figures figures-size">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Share");
                  handleClickin(event);
                  handleShareClick(i);
                  openShareModal();
                }}
              >
                {share[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_110_30)">
                      <rect x="1" y="9" width="22" height="15" fill="black" />
                      <path
                        d="M0 10C0 9.44772 0.447715 9 1 9V23H0V10Z"
                        fill="black"
                      />
                      <path
                        d="M23 9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                        fill="black"
                      />
                      <path
                        d="M24 23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23H24Z"
                        fill="black"
                      />
                      <path d="M6 9V10L1 10L1 9H6Z" fill="black" />
                      <path d="M23 9V10L18 10V9L23 9Z" fill="black" />
                      <rect x="11" y="9" width="2" height="7" fill="white" />
                      <path
                        d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_110_30">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_64)">
                      <path
                        d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                        fill="black"
                      />
                      <path
                        d="M0 10C0 9.44772 0.447715 9 1 9V9V23H0V10Z"
                        fill="black"
                      />
                      <path
                        d="M23 9V9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                        fill="black"
                      />
                      <path
                        d="M24 23V23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23V23L24 23Z"
                        fill="black"
                      />
                      <rect
                        x="6"
                        y="9"
                        width="1"
                        height="5"
                        transform="rotate(90 6 9)"
                        fill="black"
                      />
                      <rect
                        x="23"
                        y="9"
                        width="1"
                        height="5"
                        transform="rotate(90 23 9)"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_64">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <>
                {isShareOption && (
                  <div className="modal sharemodal ">
                    <div className="modal-content share-card">
                      <span className="Close shareclose" onClick={closeModal}>
                        &times;
                      </span>
                      <div className="mb-3.5">
                        <h1 className="ml-2 font-bold text-base">
                          Share With:
                        </h1>
                      </div>
                      <div className="d-flex contents ml-2">
                        <FacebookShareButton
                          url={shareCard(index)}
                          className="ml-2"
                        >
                          <FacebookIcon></FacebookIcon>
                        </FacebookShareButton>

                        <TwitterShareButton
                          url={shareCard(index)}
                          className="ml-2"
                        >
                          <TwitterIcon></TwitterIcon>
                        </TwitterShareButton>
                        <WhatsappShareButton
                          url={window.location.href}
                          className="ml-2"
                        >
                          <WhatsappIcon></WhatsappIcon>
                        </WhatsappShareButton>
                        <LinkedinShareButton
                          url={window.location.href}
                          className="ml-2"
                        >
                          <LinkedinIcon></LinkedinIcon>
                        </LinkedinShareButton>
                        <EmailShareButton
                          className="ml-2"
                          url={shareCard(index)}
                        >
                          <EmailIcon></EmailIcon>
                        </EmailShareButton>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <span className="figures figures-size">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Support");
                  handleClickin(event);
                  handleSupportClick(i);
                  openSupportModel();
                }}
              >
                {support[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_110_26)">
                      <path
                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
                        fill="#FCD12A"
                      />
                      <path
                        d="M11.9998 0C5.38038 0 0 5.38038 0 11.9998C0 18.6192 5.38038 24 11.9998 24C18.6192 24 24 18.6196 24 11.9998C24 5.37994 18.6196 0 11.9998 0ZM11.9998 1.33327C17.8989 1.33327 22.6666 6.10099 22.6666 12.0001C22.6666 17.8992 17.8989 22.6669 11.9998 22.6669C6.10112 22.6669 1.33297 17.8992 1.33297 12.0001C1.33297 6.10143 6.10068 1.33327 11.9998 1.33327Z"
                        fill="#FCD12A"
                      />
                      <path
                        d="M12.0136 6.00004C10.3356 6.01744 8.8123 7.10205 8.08658 8.71894C7.9944 8.88159 7.97493 9.07526 8.03248 9.25306C8.0902 9.43069 8.21976 9.57612 8.38965 9.65382C8.55954 9.73136 8.75441 9.73411 8.92637 9.6614C9.0985 9.58869 9.2322 9.44706 9.29492 9.27097C9.82286 8.0945 10.9304 7.34933 12.024 7.33345H12.0345C13.0021 7.34275 13.7444 7.62981 14.2428 8.08348C14.7432 8.53885 15.024 9.16829 15.024 10.0001C15.024 10.4326 14.88 10.7689 14.5969 11.1459C14.3138 11.5229 13.8855 11.9074 13.4303 12.3128C12.5198 13.1234 11.3894 14.0954 11.3573 15.6461C11.3529 15.823 11.419 15.9946 11.5412 16.1228C11.6633 16.251 11.8313 16.3253 12.0085 16.3294C12.1854 16.3335 12.3569 16.2672 12.4849 16.1449C12.6127 16.0225 12.6868 15.8544 12.6908 15.6772C12.7092 14.7795 13.4055 14.1233 14.3158 13.3126C14.771 12.9074 15.2631 12.4761 15.6595 11.9482C16.056 11.42 16.3575 10.7675 16.3575 10.0001C16.3575 8.84316 15.9188 7.804 15.1387 7.09376C14.3585 6.3837 13.2623 6.00895 12.024 6L12.0136 6.00004ZM11.6907 17.3338C11.506 17.3338 11.3573 17.4825 11.3573 17.667V18.3338C11.3573 18.5185 11.506 18.667 11.6907 18.667H12.3574C12.5421 18.667 12.6908 18.5185 12.6908 18.3338V17.667C12.6908 17.4825 12.5421 17.3338 12.3574 17.3338H11.6907Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_110_26">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_67)">
                      <circle cx="12" cy="12" r="11.5" stroke="black" />
                      <path
                        d="M11.208 14.3426V14.2744C11.2156 13.551 11.2913 12.9752 11.4353 12.5472C11.5792 12.1191 11.7837 11.7726 12.0489 11.5074C12.314 11.2423 12.6322 10.9979 13.0034 10.7744C13.2269 10.6381 13.4277 10.4771 13.6057 10.2915C13.7837 10.1021 13.9239 9.8843 14.0262 9.63808C14.1322 9.39187 14.1853 9.11914 14.1853 8.8199C14.1853 8.44869 14.0981 8.12672 13.9239 7.85399C13.7497 7.58127 13.5167 7.37104 13.225 7.22331C12.9334 7.07558 12.6095 7.00172 12.2534 7.00172C11.9428 7.00172 11.6436 7.06611 11.3557 7.1949C11.0678 7.32369 10.8273 7.52634 10.6341 7.80286C10.4409 8.07937 10.3292 8.44111 10.2989 8.88808H8.86708C8.89738 8.24414 9.06405 7.69301 9.36708 7.23467C9.67389 6.77634 10.0773 6.42596 10.5773 6.18354C11.0811 5.94111 11.6398 5.8199 12.2534 5.8199C12.9201 5.8199 13.4997 5.95248 13.9921 6.21763C14.4883 6.48278 14.8709 6.84642 15.1398 7.30854C15.4125 7.77066 15.5489 8.29717 15.5489 8.88808C15.5489 9.30475 15.4845 9.68164 15.3557 10.0188C15.2307 10.3559 15.0489 10.657 14.8103 10.9222C14.5754 11.1873 14.2913 11.4222 13.958 11.6267C13.6247 11.8351 13.3576 12.0548 13.1568 12.2858C12.9561 12.5131 12.8103 12.7839 12.7193 13.0983C12.6284 13.4127 12.5792 13.8048 12.5716 14.2744V14.3426H11.208ZM11.9353 17.7063C11.655 17.7063 11.4144 17.6059 11.2137 17.4051C11.0129 17.2044 10.9125 16.9638 10.9125 16.6835C10.9125 16.4032 11.0129 16.1627 11.2137 15.9619C11.4144 15.7612 11.655 15.6608 11.9353 15.6608C12.2156 15.6608 12.4561 15.7612 12.6568 15.9619C12.8576 16.1627 12.958 16.4032 12.958 16.6835C12.958 16.8691 12.9106 17.0396 12.8159 17.1949C12.725 17.3502 12.6019 17.4752 12.4466 17.5699C12.2951 17.6608 12.1247 17.7063 11.9353 17.7063Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_67">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <>
                {showModalsupport && (
                  <div className="modal sharemodal">
                    <div className="modal-content">
                      <span
                        className="Close shareclose closesupport"
                        onClick={closeModalsupport}
                      >
                        &times;
                      </span>
                      <h2 className="flex justify-center font-bold">
                        Contact Us
                      </h2>
                      <p className="mt-2 mb-4 font-medium">
                        Have a question? Select an option below to contct us
                      </p>
                      <div className="flex justify-around items-center ">
                        <button
                          onClick={() => handlePhoneClick("123-456-7890")}
                          className="flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-telephone"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                          </svg>
                          <span className="ml-1.5">Call</span>
                        </button>
                        <button
                          onClick={() =>
                            handleEmailClick("example@example.com")
                          }
                          className="flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-envelope"
                            viewBox="0 0 16 16"
                          >
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                          </svg>
                          <span className="ml-1.5">Email</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <span className="figures figures-size">0</span>
            </div>
          </div>
        </div>
        <div className="text-center flex justify-center ">
          <span className="figures figures-size">0 View</span>
          {/* <span className="figures">views</span> */}
        </div>
      </>
    );
  }
  // Interaction pop-Up
  function returnInteractionPopUp(post, index) {
    let newid = post.id;
    let newschoolId = "";
    for (var i in interactions) {
      let schoopAppC = school_id;
      newschoolId = newid.concat(schoopAppC);
      if (newid === interactions[i].id) {
        return (
          <>
            <div className="flex flex-col flex-row">
              <div className="flex justify-center gap-5 md:gap-3 relative">
                <div key={i} className=" text-sm mb-2 flex gap-1">
                  <button
                    id="like-button"
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Like"
                      );
                      handleClickin(event);
                      handleLikeClick(index);
                    }}
                  >
                    {liked[index] ? (
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="likesanimation"
                      >
                        <g clip-path="url(#clip0_107_13)">
                          <path
                            d="M1.5 9.5C2.3 14.3 8.83333 20.1667 12 22.5L16 19.5C17.6666 18 21.4 13.7 23 8.5C23.4 0.900004 17.5 0.666671 14.5 1.5C14.1667 1.66667 13.1 2.3 11.5 3.5C6.5 -1.5 0.5 3.5 1.5 9.5Z"
                            fill="#F54438"
                          />
                          <path
                            d="M6.2812 0.0143438C5.07183 0.191295 4.08745 0.582733 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.4972C23.3296 3.24773 21.2531 0.834754 18.4031 0.132311C17.7703 -0.0231918 16.4578 -0.0339152 15.8203 0.110863C14.5312 0.40042 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765046 9.05152 0.293177 8.17027 0.116226C7.76245 0.0304316 6.59995 -0.0285535 6.2812 0.0143438ZM7.61714 1.75705C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56146 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56146 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829393 20.6578 2.13776 21.9609 5.24781C23.1796 8.15947 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75705Z"
                            fill="#F54438"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_107_13">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"

                      >
                        <g clip-path="url(#clip0_4_37)">
                          <path
                            d="M6.2812 0.0143425C5.07183 0.191294 4.08745 0.582731 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.49719C23.3296 3.24773 21.2531 0.834753 18.4031 0.13231C17.7703 -0.0231931 16.4578 -0.0339165 15.8203 0.110862C14.5312 0.400418 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765044 9.05152 0.293176 8.17027 0.116225C7.76245 0.0304303 6.59995 -0.0285548 6.2812 0.0143425ZM7.61714 1.75704C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56145 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56145 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829392 20.6578 2.13776 21.9609 5.24781C23.1796 8.15946 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75704Z"
                            fill="#F54438"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_37">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {liked[index] && <span className="namepop">Like</span>}
                  <span className="figures">
                    {interactions[i].interactions.likes !== undefined && interactions[i].interactions.likes !== null
                      ? NumberFormat(interactions[i].interactions.likes)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    id="share-button"
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Thanks"
                      );
                      handleClickin(event);
                      handleThumbsClick(index);
                    }}
                  >
                    {thumbs[index] ? (
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"

                      >
                        <g clip-path="url(#clip0_107_16)">
                          <path
                            d="M0.5 21C0.5 23.4 2.83333 23.3334 4 23L6 22.5L7 22L12.5 23.5H21C22.2 23.5 22.1667 21.1667 22 20C22.5 19.6667 23.5 18.8 23.5 18C23.5 17.2 22.5 16.6667 22 16.5C22.3333 16.3334 23 15.7 23 14.5C23 13.3 22 13 21.5 13C22 13 23.1 12.7 23.5 11.5C23.9 10.3 22.3333 9.66669 21.5 9.50003H14.5L15 8.00002C15.1667 7.00003 15.3 4.40006 14.5 2.00006C13.5 -0.999944 11 1.00006 11 3.50006C11 6.00006 8 9.50003 8 10C8 10.4 7 10.5 6.5 10.5001C6.23238 10.3334 5.65772 9.90003 5.5 9.50003C5.34228 9.10003 3.43428 9.33336 2.5 9.50003L0.5 10V21Z"
                            fill="#2295F1"
                          />
                          <path
                            d="M12.1744 0.0286915C11.3391 0.193104 10.9325 0.862092 10.6373 2.57425C10.1305 5.52233 9.55688 7.08141 8.47087 8.49309C7.98635 9.12239 6.87806 10.1939 6.80009 10.1089C6.78895 10.0975 6.72769 9.98414 6.66643 9.85375C6.60517 9.72902 6.44923 9.53059 6.32113 9.41153C5.87002 8.99767 5.94242 9.00901 3.42511 9.00901C1.24195 9.00901 1.15841 9.01468 0.913362 9.12806C0.590344 9.28114 0.300741 9.57595 0.133663 9.92178L0 10.1996V22.3321L0.15594 22.6552C0.323018 23.0011 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68623 23.517 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6496C6.7444 22.5192 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62682 23.2619 10.2753 23.7494 11.5952 23.9195C12.2079 23.9989 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9989 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5746C22.305 20.5065 22.3662 20.4442 22.7115 20.2741C23.3631 19.9453 23.8588 19.2649 23.9758 18.5393C24.076 17.9156 23.8588 17.1673 23.4467 16.7024L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25279 22.1435 8.92397C21.9597 8.88995 20.5005 8.86727 18.4287 8.86727C15.7276 8.86727 15.0092 8.85026 15.0092 8.79357C15.0092 8.75955 15.1819 8.06222 15.3935 7.25149C15.9059 5.27855 15.9226 5.20485 15.917 4.38845C15.9114 3.82718 15.8836 3.56639 15.7722 3.12985C15.5104 2.10936 14.9368 1.16257 14.2685 0.652324C13.6392 0.170426 12.7815 -0.0903657 12.1744 0.0286915ZM13.0989 1.28163C14.0012 1.62179 14.6583 2.68764 14.8087 4.07664C14.8755 4.63791 14.7586 5.28422 14.2239 7.30819C13.9455 8.36836 13.7171 9.33216 13.7116 9.44555C13.706 9.60996 13.7394 9.695 13.8564 9.81406L14.0067 9.9728L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7757 22.305 12.2122C22.0599 12.3483 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7395 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5162L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5175C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8158L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0709 22.6336 17.4677C23.0902 18.0347 22.8842 18.9418 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3727 19.1583 19.4407C18.8186 19.6108 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3683 21.6199 22.5589 20.7623 22.814C20.6119 22.8593 19.2697 22.8707 16.1231 22.8537C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V11.5546L7.43499 11.084C8.69365 10.1315 9.62372 9.01468 10.2976 7.6767C10.9325 6.41243 11.3056 5.16516 11.6621 3.14119C11.9294 1.63313 12.0631 1.26462 12.3916 1.13989C12.503 1.10021 12.7425 1.14556 13.0989 1.28163ZM5.56371 10.2336L5.70851 10.347V22.1847L5.56371 22.2981C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.11386 22.145V10.3867L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                            fill="#2295F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_107_16">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_4_46)">
                          <path
                            d="M12.1744 0.0286594C11.3391 0.193072 10.9325 0.86206 10.6373 2.57422C10.1305 5.5223 9.55688 7.08138 8.47088 8.49306C7.98635 9.12236 6.87806 10.1939 6.80009 10.1088C6.78895 10.0975 6.72769 9.98411 6.66643 9.85371C6.60517 9.72899 6.44923 9.53056 6.32113 9.4115C5.87002 8.99764 5.94242 9.00898 3.42511 9.00898C1.24195 9.00898 1.15841 9.01464 0.913362 9.12803C0.590344 9.28111 0.300741 9.57591 0.133663 9.92175L0 10.1995V16.2658V22.332L0.15594 22.6552C0.323018 23.001 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68624 23.5169 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6495C6.7444 22.5191 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62681 23.2618 10.2753 23.7494 11.5952 23.9195C12.2079 23.9988 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9988 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5745C22.305 20.5065 22.3662 20.4441 22.7115 20.2741C23.3631 19.9452 23.8588 19.2649 23.9758 18.5392C24.076 17.9156 23.8588 17.1672 23.4467 16.7023L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25276 22.1435 8.92393C21.9597 8.88992 20.5005 8.86724 18.4287 8.86724C15.7276 8.86724 15.0092 8.85023 15.0092 8.79354C15.0092 8.75952 15.1819 8.06219 15.3935 7.25146C15.9059 5.27852 15.9226 5.20481 15.917 4.38842C15.9114 3.82715 15.8836 3.56636 15.7722 3.12982C15.5104 2.10933 14.9368 1.16254 14.2685 0.652292C13.6392 0.170394 12.7815 -0.0903978 12.1744 0.0286594ZM13.0989 1.28159C14.0012 1.62176 14.6583 2.6876 14.8087 4.0766C14.8755 4.63787 14.7586 5.28419 14.2239 7.30816C13.9455 8.36833 13.7171 9.33213 13.7116 9.44552C13.706 9.60993 13.7394 9.69497 13.8564 9.81403L14.0067 9.97277L18.0333 10.0011L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7756 22.305 12.2122C22.0599 12.3482 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7394 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5161L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5174C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8157L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0708 22.6336 17.4677C23.0902 18.0346 22.8842 18.9417 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3726 19.1583 19.4407C18.8186 19.6107 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3682 21.6199 22.5588 20.7623 22.8139C20.6119 22.8593 19.2697 22.8706 16.1231 22.8536C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V16.2998V11.5545L7.43499 11.084C8.69365 10.1315 9.62372 9.01464 10.2976 7.67667C10.9325 6.41239 11.3056 5.16513 11.6621 3.14116C11.9294 1.6331 12.0631 1.26459 12.3916 1.13986C12.503 1.10017 12.7425 1.14553 13.0989 1.28159ZM5.56371 10.2336L5.70851 10.347V16.2658V22.1846L5.56371 22.298C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.2698 22.281L1.11386 22.145V16.2658V10.3866L1.2698 10.2506L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                            fill="#2295F1"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_46">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {thumbs[index] && <span className="namepop">Thanks</span>}
                  <span className="figures">
                    {interactions[i].interactions.thanks !== undefined && interactions[i].interactions.thanks !== null
                      ? NumberFormat(interactions[i].interactions.thanks)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Helpful"
                      );
                      handleClickin(event);
                      handleHelpfulClick(index);
                    }}
                  >
                    {help[index] ? (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_106_7)">
                          <path
                            d="M0.5 14L2.5 16L2 17L9.5 23.5C10 23.1667 11.3 22.4 12.5 22C13.7 21.6 16.3333 19.8333 17.5 19C19 17.8333 22.2 15.3 23 14.5C23.8 13.7 23.3333 12.5 23 12C22.3333 12 21.2 11.8 22 11C22.8 10.2 22.3333 8.99999 22 8.49999C21.5 8.33332 20.6 7.79999 21 6.99999C21.8 4.99999 20 4.49997 19 4.49996C19.1667 4.16664 19.4 3.29999 19 2.49999C18.5 1.49999 17.5 1.49999 16 1.99999C15.6 1.09673e-05 13.8333 0.499999 13 0.99999L7.5 5.99999C7.16667 5.99998 6.4 5.69996 6 4.49996C5.6 2.49996 3.83333 3.3333 3 3.99996C2.66667 6.16663 2 10.7 2 11.5C2 12.3 1 13.5 0.5 14Z"
                            fill="#4EAF51"
                          />
                          <path
                            d="M13.6079 0.0377471C12.989 0.150247 12.9625 0.168997 9.74081 3.00962C7.25441 5.20806 6.71481 5.66275 6.73597 5.54556C6.92113 4.53775 6.71481 3.87212 6.05882 3.32837C5.57742 2.93462 5.27058 2.8315 4.54583 2.8315C3.83694 2.8315 3.51424 2.93462 3.05928 3.30493C2.71012 3.59556 2.51439 3.85806 2.398 4.20025C2.35039 4.3315 2.20226 5.70025 2.03298 7.53775C1.87427 9.25337 1.72086 10.7909 1.68911 10.9596C1.5357 11.7846 1.11777 12.5346 0.419466 13.2331C0.0121201 13.6409 -0.0725232 13.894 0.0544417 14.3112C0.102054 14.4612 0.297791 14.6627 1.03313 15.3237L1.95363 16.144L1.81608 16.2612C1.51983 16.5049 1.38757 16.8799 1.4828 17.2221C1.54099 17.4424 1.6997 17.5877 5.09601 20.6112C7.51892 22.7674 8.71451 23.794 8.85734 23.8549C9.30701 24.0424 9.70907 23.9393 10.2645 23.4987C10.8465 23.0346 11.2274 22.8471 12.3383 22.4674C14.1264 21.8627 15.9515 20.8737 17.8295 19.4862C18.7289 18.8252 23.4583 14.6487 23.6858 14.3206C23.9397 13.9502 24.0508 13.4346 23.9715 13.0174C23.818 12.2206 23.1832 11.5877 22.3315 11.3862L22.1093 11.3299L22.4056 11.0159C22.7706 10.6362 22.9293 10.3409 23.0086 9.90493C23.1568 9.09868 22.6542 8.2315 21.8289 7.86587C21.6491 7.78618 21.4163 7.71118 21.3052 7.69712L21.1042 7.66431L21.2629 7.49087C21.6385 7.069 21.8131 6.48306 21.7284 5.92993C21.612 5.16118 20.8873 4.47212 20.0144 4.29868C19.7816 4.25181 19.734 4.22368 19.7605 4.16743C20.0038 3.67056 20.062 3.12212 19.9139 2.67681C19.7287 2.12368 19.1732 1.61275 18.5173 1.39243C17.9195 1.19087 17.0783 1.27993 16.5281 1.60806C16.4223 1.67368 16.3324 1.72525 16.3218 1.72525C16.3112 1.72525 16.2901 1.64556 16.2689 1.54712C16.1896 1.08306 15.6553 0.46431 15.1368 0.229935C14.666 0.0189971 14.1211 -0.0513154 13.6079 0.0377471ZM14.6819 0.918997C15.158 1.13462 15.4119 1.50962 15.4172 1.98306C15.4172 2.25493 15.3907 2.35337 15.2691 2.55025C15.1633 2.71431 14.1052 3.67993 11.6241 5.87837C8.27013 8.84556 8.13258 8.95806 8.15903 8.77993C8.24368 8.25493 8.25955 7.58462 8.19607 7.34556C8.10084 6.994 7.9104 6.67056 7.64059 6.41743L7.40783 6.19712L10.328 3.61431C13.0366 1.219 13.3858 0.93306 13.7508 0.829935C13.9624 0.768997 14.4544 0.815872 14.6819 0.918997ZM18.1469 2.12837C18.3638 2.18462 18.4961 2.25962 18.7077 2.45181C18.9987 2.719 19.0939 2.91587 19.0939 3.26743C19.0939 3.67056 18.9987 3.82525 18.4379 4.34087L17.9089 4.82368L17.8401 4.58462C17.6497 3.919 17.073 3.394 16.3165 3.20181L16.015 3.12212L16.4276 2.74712C16.9408 2.28775 17.0889 2.18931 17.3957 2.119C17.7237 2.03931 17.8084 2.03931 18.1469 2.12837ZM4.97962 3.6565C5.26 3.7315 5.67793 4.069 5.78902 4.31275C5.88954 4.52837 5.9107 4.95025 5.84193 5.49868L5.81018 5.794L5.56154 5.82212C4.78388 5.91587 4.00622 6.56743 3.81049 7.30806C3.77875 7.42056 3.62004 8.93931 3.46133 10.6784C3.25502 12.8956 3.13863 13.9549 3.06457 14.2315C2.96934 14.5924 2.562 15.4596 2.48794 15.4596C2.42445 15.4596 0.895584 14.0721 0.895584 14.0159C0.895584 13.9784 1.01726 13.8331 1.16538 13.6877C1.87956 12.994 2.41387 12.0143 2.58316 11.0768C2.6149 10.894 2.77361 9.34243 2.93231 7.62212C3.11747 5.57368 3.24443 4.43931 3.29205 4.33618C3.55656 3.77837 4.30248 3.47368 4.97962 3.6565ZM16.2901 4.02212C16.7609 4.23306 17.0307 4.61743 17.0307 5.07681C17.0307 5.59243 17.0519 5.569 14.1475 8.14712C12.6822 9.45025 11.4548 10.5706 11.4284 10.6409C11.3279 10.8846 11.5395 11.1471 11.841 11.1471C12.0209 11.1471 12.206 10.9877 15.3643 8.20337C17.5703 6.25337 18.7712 5.22681 18.9087 5.16587C19.2156 5.03462 19.8398 5.044 20.1308 5.17993C20.4111 5.31118 20.6968 5.6065 20.7762 5.84556C20.8714 6.12212 20.8502 6.50181 20.7286 6.74087C20.6492 6.90025 19.8398 7.64556 17.2952 9.90493C14.1105 12.7315 13.9624 12.8674 13.9624 13.0315C13.9624 13.2612 14.2216 13.4674 14.4597 13.4252C14.5866 13.4018 15.2373 12.8534 17.2952 11.0346C19.1468 9.39868 20.0408 8.63931 20.2048 8.56431C20.5487 8.40962 21.0407 8.419 21.4004 8.58306C21.866 8.794 22.1199 9.14556 22.1252 9.60025C22.1358 10.1206 22.2204 10.0315 19.279 12.6471C17.3534 14.3534 16.5493 15.1034 16.5228 15.1971C16.4488 15.469 16.7556 15.7409 17.0625 15.6752C17.1683 15.6518 17.8084 15.1221 19.1468 13.9409C21.2364 12.1034 21.1994 12.1268 21.7707 12.1315C22.2839 12.1362 22.6859 12.3518 22.9293 12.7502C23.1303 13.0737 23.1409 13.5002 22.9663 13.8237C22.8817 13.9737 22.1887 14.6206 20.4323 16.1674C19.0992 17.3393 17.7396 18.5065 17.4063 18.7549C15.5653 20.1471 13.8037 21.1081 11.878 21.7737C11.476 21.9096 11.0263 22.0784 10.8729 22.1487C10.4761 22.3268 9.89422 22.6924 9.62442 22.9362C9.49746 23.0534 9.35462 23.1471 9.30701 23.1471C9.26469 23.1471 7.66705 21.769 5.76786 20.0815C2.54084 17.2221 2.31336 17.0065 2.38213 16.9221C2.42445 16.8752 2.6149 16.6596 2.80535 16.4487C3.15979 16.0596 3.55656 15.4456 3.747 14.9909C4.00622 14.3721 4.06442 13.9784 4.36067 10.7487C4.52466 8.99556 4.68337 7.4815 4.71511 7.38306C4.78917 7.15806 5.13304 6.81118 5.38697 6.69868C6.00592 6.41743 6.75184 6.60962 7.13803 7.14868C7.34963 7.444 7.37079 7.62212 7.27557 8.61587C7.14332 9.97993 7.15919 10.1018 7.49247 10.2518C7.80988 10.3971 7.68292 10.4956 11.4495 7.16743C14.7295 4.26587 15.0151 4.02212 15.2585 3.9565C15.5812 3.86743 16.0044 3.89556 16.2901 4.02212Z"
                            fill="#90EE90"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_106_7">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_4_40)">
                          <path
                            d="M13.6112 0.0937247C12.9923 0.206225 12.9658 0.224975 9.7441 3.0656C7.25771 5.26404 6.71811 5.71872 6.73927 5.60154C6.92442 4.59372 6.71811 3.9281 6.06212 3.38435C5.58071 2.9906 5.27388 2.88747 4.54912 2.88747C3.84023 2.88747 3.51753 2.9906 3.06257 3.36091C2.71342 3.65154 2.51768 3.91404 2.4013 4.25622C2.35369 4.38747 2.20556 5.75622 2.03627 7.59372C1.87757 9.30935 1.72415 10.8468 1.69241 11.0156C1.53899 11.8406 1.12107 12.5906 0.422762 13.289C0.015416 13.6968 -0.0692273 13.95 0.0577376 14.3672C0.105349 14.5172 0.301087 14.7187 1.03643 15.3797L1.95692 16.2L1.81938 16.3172C1.52312 16.5609 1.39087 16.9359 1.48609 17.2781C1.54429 17.4984 1.70299 17.6437 5.0993 20.6672C7.52222 22.8234 8.7178 23.85 8.86064 23.9109C9.31031 24.0984 9.71236 23.9953 10.2678 23.5547C10.8498 23.0906 11.2306 22.9031 12.3416 22.5234C14.1297 21.9187 15.9548 20.9297 17.8328 19.5422C18.7322 18.8812 23.4616 14.7047 23.6891 14.3765C23.943 14.0062 24.0541 13.4906 23.9748 13.0734C23.8213 12.2765 23.1865 11.6437 22.3348 11.4422L22.1126 11.3859L22.4089 11.0718C22.7739 10.6922 22.9326 10.3968 23.0119 9.96091C23.1601 9.15466 22.6575 8.28747 21.8322 7.92185C21.6524 7.84216 21.4196 7.76716 21.3085 7.7531L21.1075 7.72029L21.2662 7.54685C21.6418 7.12497 21.8163 6.53904 21.7317 5.98591C21.6153 5.21716 20.8906 4.5281 20.0177 4.35466C19.7849 4.30779 19.7373 4.27966 19.7637 4.22341C20.0071 3.72654 20.0653 3.1781 19.9172 2.73279C19.732 2.17966 19.1765 1.66872 18.5206 1.44841C17.9228 1.24685 17.0816 1.33591 16.5314 1.66404C16.4256 1.72966 16.3357 1.78122 16.3251 1.78122C16.3145 1.78122 16.2934 1.70154 16.2722 1.6031C16.1929 1.13904 15.6586 0.520287 15.1401 0.285912C14.6693 0.0749747 14.1244 0.00466223 13.6112 0.0937247ZM14.6852 0.974975C15.1613 1.1906 15.4152 1.5656 15.4205 2.03904C15.4205 2.31091 15.394 2.40935 15.2724 2.60622C15.1666 2.77029 14.1085 3.73591 11.6274 5.93435C8.27343 8.90154 8.13588 9.01404 8.16233 8.83591C8.24697 8.31091 8.26284 7.6406 8.19936 7.40154C8.10414 7.04997 7.91369 6.72654 7.64389 6.47341L7.41112 6.2531L10.3313 3.67029C13.0399 1.27497 13.3891 0.989037 13.7541 0.885912C13.9657 0.824975 14.4577 0.87185 14.6852 0.974975ZM18.1502 2.18435C18.3671 2.2406 18.4994 2.3156 18.711 2.50779C19.002 2.77497 19.0972 2.97185 19.0972 3.32341C19.0972 3.72654 19.002 3.88122 18.4412 4.39685L17.9122 4.87966L17.8434 4.6406C17.653 3.97497 17.0763 3.44997 16.3198 3.25779L16.0183 3.1781L16.4309 2.8031C16.9441 2.34372 17.0922 2.24529 17.399 2.17497C17.727 2.09529 17.8117 2.09529 18.1502 2.18435ZM4.98292 3.71247C5.2633 3.78747 5.68123 4.12497 5.79232 4.36872C5.89283 4.58435 5.91399 5.00622 5.84522 5.55466L5.81348 5.84997L5.56484 5.8781C4.78718 5.97185 4.00952 6.62341 3.81378 7.36404C3.78204 7.47654 3.62334 8.99529 3.46463 10.7343C3.25831 12.9515 3.14193 14.0109 3.06786 14.2875C2.97264 14.6484 2.56529 15.5156 2.49123 15.5156C2.42775 15.5156 0.89888 14.1281 0.89888 14.0718C0.89888 14.0343 1.02055 13.889 1.16868 13.7437C1.88286 13.05 2.41717 12.0703 2.58646 11.1328C2.6182 10.95 2.7769 9.39841 2.93561 7.6781C3.12077 5.62966 3.24773 4.49529 3.29534 4.39216C3.55985 3.83435 4.30577 3.52966 4.98292 3.71247ZM16.2934 4.0781C16.7642 4.28904 17.034 4.67341 17.034 5.13279C17.034 5.64841 17.0552 5.62497 14.1508 8.2031C12.6855 9.50622 11.4581 10.6265 11.4317 10.6968C11.3312 10.9406 11.5428 11.2031 11.8443 11.2031C12.0242 11.2031 12.2093 11.0437 15.3676 8.25935C17.5736 6.30935 18.7745 5.28279 18.912 5.22185C19.2189 5.0906 19.8431 5.09997 20.1341 5.23591C20.4144 5.36716 20.7001 5.66247 20.7795 5.90154C20.8747 6.1781 20.8535 6.55779 20.7319 6.79685C20.6525 6.95622 19.8431 7.70154 17.2985 9.96091C14.1138 12.7875 13.9657 12.9234 13.9657 13.0875C13.9657 13.3172 14.2249 13.5234 14.463 13.4812C14.5899 13.4578 15.2406 12.9093 17.2985 11.0906C19.1501 9.45466 20.0441 8.69529 20.2081 8.62029C20.552 8.4656 21.044 8.47497 21.4037 8.63904C21.8693 8.84997 22.1232 9.20154 22.1285 9.65622C22.1391 10.1765 22.2237 10.0875 19.2823 12.7031C17.3567 14.4093 16.5526 15.1593 16.5261 15.2531C16.4521 15.525 16.7589 15.7968 17.0657 15.7312C17.1715 15.7078 17.8117 15.1781 19.1501 13.9968C21.2397 12.1593 21.2027 12.1828 21.774 12.1875C22.2872 12.1922 22.6892 12.4078 22.9326 12.8062C23.1336 13.1297 23.1442 13.5562 22.9696 13.8797C22.885 14.0297 22.192 14.6765 20.4356 16.2234C19.1025 17.3953 17.7429 18.5625 17.4096 18.8109C15.5686 20.2031 13.807 21.164 11.8813 21.8297C11.4793 21.9656 11.0296 22.1343 10.8762 22.2047C10.4794 22.3828 9.89752 22.7484 9.62772 22.9922C9.50075 23.1093 9.35792 23.2031 9.31031 23.2031C9.26798 23.2031 7.67034 21.825 5.77116 20.1375C2.54413 17.2781 2.31666 17.0625 2.38543 16.9781C2.42775 16.9312 2.6182 16.7156 2.80864 16.5047C3.16309 16.1156 3.55985 15.5015 3.7503 15.0468C4.00952 14.4281 4.06771 14.0343 4.36396 10.8047C4.52796 9.05154 4.68667 7.53747 4.71841 7.43904C4.79247 7.21404 5.13633 6.86716 5.39026 6.75466C6.00922 6.47341 6.75514 6.6656 7.14132 7.20466C7.35293 7.49997 7.37409 7.6781 7.27887 8.67185C7.14661 10.0359 7.16248 10.1578 7.49577 10.3078C7.81318 10.4531 7.68621 10.5515 11.4528 7.22341C14.7328 4.32185 15.0184 4.0781 15.2618 4.01247C15.5845 3.92341 16.0077 3.95154 16.2934 4.0781Z"
                            fill="#4EAF51"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_40">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {help[index] && <span className="namepop">Helpful</span>}
                  <span className="figures">
                    {interactions[i].interactions.helpful !== undefined && interactions[i].interactions.helpful !== null
                      ? NumberFormat(interactions[i].interactions.helpful)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Share"
                      );
                      handleClickin(event);
                      handleShareClick(index);
                      openShareModal();
                    }}
                  >
                    {share[index] ? (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_110_30)">
                          <rect
                            x="1"
                            y="9"
                            width="22"
                            height="15"
                            fill="black"
                          />
                          <path
                            d="M0 10C0 9.44772 0.447715 9 1 9V23H0V10Z"
                            fill="black"
                          />
                          <path
                            d="M23 9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                            fill="black"
                          />
                          <path
                            d="M24 23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23H24Z"
                            fill="black"
                          />
                          <path d="M6 9V10L1 10L1 9H6Z" fill="black" />
                          <path d="M23 9V10L18 10V9L23 9Z" fill="black" />
                          <rect
                            x="11"
                            y="9"
                            width="2"
                            height="7"
                            fill="white"
                          />
                          <path
                            d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_110_30">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_4_64)">
                          <path
                            d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                            fill="black"
                          />
                          <path
                            d="M0 10C0 9.44772 0.447715 9 1 9V9V23H0V10Z"
                            fill="black"
                          />
                          <path
                            d="M23 9V9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                            fill="black"
                          />
                          <path
                            d="M24 23V23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23V23L24 23Z"
                            fill="black"
                          />
                          <rect
                            x="6"
                            y="9"
                            width="1"
                            height="5"
                            transform="rotate(90 6 9)"
                            fill="black"
                          />
                          <rect
                            x="23"
                            y="9"
                            width="1"
                            height="5"
                            transform="rotate(90 23 9)"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_64">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {share[index] && <span className="namepop">Share</span>}
                  <>
                    {isShareOption && (
                      <div className="modal sharemodal ">
                        <div className="modal-content share-card">
                          <span
                            className="Close shareclose"
                            onClick={closeModalshare}
                          >
                            &times;
                          </span>
                          <div className="mb-3.5">
                            <h1 className="ml-2 font-bold text-base">
                              Share With:
                            </h1>
                          </div>
                          <div className="d-flex contents ml-2">
                            <FacebookShareButton
                              url={shareCard(index)}
                              className="ml-2"
                            >
                              <FacebookIcon></FacebookIcon>
                            </FacebookShareButton>

                            <TwitterShareButton
                              url={shareCard(index)}
                              className="ml-2"
                            >
                              <TwitterIcon></TwitterIcon>
                            </TwitterShareButton>
                            <WhatsappShareButton
                              url={window.location.href}
                              className="ml-2"
                            >
                              <WhatsappIcon></WhatsappIcon>
                            </WhatsappShareButton>
                            <LinkedinShareButton
                              url={window.location.href}
                              className="ml-2"
                            >
                              <LinkedinIcon></LinkedinIcon>
                            </LinkedinShareButton>
                            <EmailShareButton
                              className="ml-2"
                              url={shareCard(index)}
                            >
                              <EmailIcon></EmailIcon>
                            </EmailShareButton>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  <span className="figures">
                    {interactions[i].interactions.shares !== undefined && interactions[i].interactions.shares !== null
                      ? NumberFormat(interactions[i].interactions.shares)
                      : 0}
                  </span>
                </div>
                <div className=" text-sm mb-2 flex gap-1 sppot">
                  <button
                    onClick={(event) => {
                      postData(
                        newschoolId,
                        post.title,
                        "Support"
                      );
                      handleClickin(event);
                      handleSupportClick(index);
                      openSupportModel();
                    }}
                  >
                    {support[index] ? (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="HeartAnimation"
                      >
                        <g clip-path="url(#clip0_110_26)">
                          <path
                            d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
                            fill="#FCD12A"
                          />
                          <path
                            d="M11.9998 0C5.38038 0 0 5.38038 0 11.9998C0 18.6192 5.38038 24 11.9998 24C18.6192 24 24 18.6196 24 11.9998C24 5.37994 18.6196 0 11.9998 0ZM11.9998 1.33327C17.8989 1.33327 22.6666 6.10099 22.6666 12.0001C22.6666 17.8992 17.8989 22.6669 11.9998 22.6669C6.10112 22.6669 1.33297 17.8992 1.33297 12.0001C1.33297 6.10143 6.10068 1.33327 11.9998 1.33327Z"
                            fill="#FCD12A"
                          />
                          <path
                            d="M12.0136 6.00004C10.3356 6.01744 8.8123 7.10205 8.08658 8.71894C7.9944 8.88159 7.97493 9.07526 8.03248 9.25306C8.0902 9.43069 8.21976 9.57612 8.38965 9.65382C8.55954 9.73136 8.75441 9.73411 8.92637 9.6614C9.0985 9.58869 9.2322 9.44706 9.29492 9.27097C9.82286 8.0945 10.9304 7.34933 12.024 7.33345H12.0345C13.0021 7.34275 13.7444 7.62981 14.2428 8.08348C14.7432 8.53885 15.024 9.16829 15.024 10.0001C15.024 10.4326 14.88 10.7689 14.5969 11.1459C14.3138 11.5229 13.8855 11.9074 13.4303 12.3128C12.5198 13.1234 11.3894 14.0954 11.3573 15.6461C11.3529 15.823 11.419 15.9946 11.5412 16.1228C11.6633 16.251 11.8313 16.3253 12.0085 16.3294C12.1854 16.3335 12.3569 16.2672 12.4849 16.1449C12.6127 16.0225 12.6868 15.8544 12.6908 15.6772C12.7092 14.7795 13.4055 14.1233 14.3158 13.3126C14.771 12.9074 15.2631 12.4761 15.6595 11.9482C16.056 11.42 16.3575 10.7675 16.3575 10.0001C16.3575 8.84316 15.9188 7.804 15.1387 7.09376C14.3585 6.3837 13.2623 6.00895 12.024 6L12.0136 6.00004ZM11.6907 17.3338C11.506 17.3338 11.3573 17.4825 11.3573 17.667V18.3338C11.3573 18.5185 11.506 18.667 11.6907 18.667H12.3574C12.5421 18.667 12.6908 18.5185 12.6908 18.3338V17.667C12.6908 17.4825 12.5421 17.3338 12.3574 17.3338H11.6907Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_110_26">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    ) : (
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_4_67)">
                          <circle cx="12" cy="12" r="11.5" stroke="black" />
                          <path
                            d="M11.208 14.3426V14.2744C11.2156 13.551 11.2913 12.9752 11.4353 12.5472C11.5792 12.1191 11.7837 11.7726 12.0489 11.5074C12.314 11.2423 12.6322 10.9979 13.0034 10.7744C13.2269 10.6381 13.4277 10.4771 13.6057 10.2915C13.7837 10.1021 13.9239 9.8843 14.0262 9.63808C14.1322 9.39187 14.1853 9.11914 14.1853 8.8199C14.1853 8.44869 14.0981 8.12672 13.9239 7.85399C13.7497 7.58127 13.5167 7.37104 13.225 7.22331C12.9334 7.07558 12.6095 7.00172 12.2534 7.00172C11.9428 7.00172 11.6436 7.06611 11.3557 7.1949C11.0678 7.32369 10.8273 7.52634 10.6341 7.80286C10.4409 8.07937 10.3292 8.44111 10.2989 8.88808H8.86708C8.89738 8.24414 9.06405 7.69301 9.36708 7.23467C9.67389 6.77634 10.0773 6.42596 10.5773 6.18354C11.0811 5.94111 11.6398 5.8199 12.2534 5.8199C12.9201 5.8199 13.4997 5.95248 13.9921 6.21763C14.4883 6.48278 14.8709 6.84642 15.1398 7.30854C15.4125 7.77066 15.5489 8.29717 15.5489 8.88808C15.5489 9.30475 15.4845 9.68164 15.3557 10.0188C15.2307 10.3559 15.0489 10.657 14.8103 10.9222C14.5754 11.1873 14.2913 11.4222 13.958 11.6267C13.6247 11.8351 13.3576 12.0548 13.1568 12.2858C12.9561 12.5131 12.8103 12.7839 12.7193 13.0983C12.6284 13.4127 12.5792 13.8048 12.5716 14.2744V14.3426H11.208ZM11.9353 17.7063C11.655 17.7063 11.4144 17.6059 11.2137 17.4051C11.0129 17.2044 10.9125 16.9638 10.9125 16.6835C10.9125 16.4032 11.0129 16.1627 11.2137 15.9619C11.4144 15.7612 11.655 15.6608 11.9353 15.6608C12.2156 15.6608 12.4561 15.7612 12.6568 15.9619C12.8576 16.1627 12.958 16.4032 12.958 16.6835C12.958 16.8691 12.9106 17.0396 12.8159 17.1949C12.725 17.3502 12.6019 17.4752 12.4466 17.5699C12.2951 17.6608 12.1247 17.7063 11.9353 17.7063Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4_67">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </button>
                  {support[index] && <span className="namepop">Support</span>}
                  <>
                    {showModalsupport && (
                      <div className="modal sharemodal ">
                        <div className="modal-content">
                          <span
                            className="Close shareclose closesupport"
                            onClick={closeModalsupport}
                          >
                            &times;
                          </span>
                          <h2 className="flex justify-center font-bold">
                            Contact Us
                          </h2>
                          <p className="mt-2 mb-4 font-medium">
                            Have a question? Select an option below to contct us
                          </p>
                          <div className="flex justify-around items-center ">
                            <button
                              onClick={() => handlePhoneClick("123-456-7890")}
                              className="flex items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                class="bi bi-telephone-fill"
                                viewBox="0 0 16 16"
                                style={{ fill: logo.Primary_Color__c }}
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                                />
                              </svg>
                              <span className="ml-1.5">Call</span>
                            </button>
                            <button
                              onClick={() =>
                                handleEmailClick("example@example.com")
                              }
                              className="flex items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-envelope-fill"
                                viewBox="0 0 16 16"
                                style={{ fill: logo.Primary_Color__c }}
                              >
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                              </svg>
                              <span className="ml-1.5">Email</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                  <span className="figures">
                    {interactions[i].interactions.support !== undefined && interactions[i].interactions.support !== null
                      ? NumberFormat(interactions[i].interactions.support)
                      : 0}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-center flex justify-center ">
              <span className="figuresPop">
                {interactions[i].interactions.views}{" "}
                {interactions[i].interactions.views === 0 ||
                  interactions[i].interactions.views === 1
                  ? "View"
                  : "Views"}
              </span>
            </div>
          </>
        );
      }
    }
    return (
      <>
        <div className="flex flex-col flex-row">
          <div className="flex justify-center gap-5">
            <div className=" text-sm mb-2 flex gap-1">
              <button
                id="like-button"
                onClick={(event) => {
                  postData(newschoolId, post.title, "Like");
                  handleClickin(event);
                  handleLikeClick(i);
                }}
              >
                {liked[i] ? (
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="likesanimation"
                  >
                    <g clip-path="url(#clip0_107_13)">
                      <path
                        d="M1.5 9.5C2.3 14.3 8.83333 20.1667 12 22.5L16 19.5C17.6666 18 21.4 13.7 23 8.5C23.4 0.900004 17.5 0.666671 14.5 1.5C14.1667 1.66667 13.1 2.3 11.5 3.5C6.5 -1.5 0.5 3.5 1.5 9.5Z"
                        fill="#F54438"
                      />
                      <path
                        d="M6.2812 0.0143438C5.07183 0.191295 4.08745 0.582733 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.4972C23.3296 3.24773 21.2531 0.834754 18.4031 0.132311C17.7703 -0.0231918 16.4578 -0.0339152 15.8203 0.110863C14.5312 0.40042 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765046 9.05152 0.293177 8.17027 0.116226C7.76245 0.0304316 6.59995 -0.0285535 6.2812 0.0143438ZM7.61714 1.75705C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56146 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56146 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829393 20.6578 2.13776 21.9609 5.24781C23.1796 8.15947 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75705Z"
                        fill="#F54438"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_107_13">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"

                  >
                    <g clip-path="url(#clip0_4_37)">
                      <path
                        d="M6.2812 0.0143425C5.07183 0.191294 4.08745 0.582731 3.20152 1.24764C1.8187 2.27181 0.829642 3.74641 0.337455 5.5052C-0.548483 8.67423 0.32808 11.9398 3.08902 15.7469C3.6187 16.4815 5.3812 18.5138 6.14058 19.2645C7.46714 20.589 8.92495 21.8544 10.4296 23.0019C11.7984 24.0422 11.9484 24.1173 12.3515 23.9028C12.6562 23.7419 14.4796 22.3317 15.4125 21.5273C17.1046 20.0742 18.3093 18.8784 19.6171 17.3502C22.1109 14.4386 23.4609 11.8808 23.8875 9.28552C24.0046 8.56699 24.0046 7.18355 23.8875 6.49719C23.3296 3.24773 21.2531 0.834753 18.4031 0.13231C17.7703 -0.0231931 16.4578 -0.0339165 15.8203 0.110862C14.5312 0.400418 13.4062 1.03852 12.4125 2.04124L12 2.45413L11.5687 2.01979C11.3296 1.78386 10.9875 1.47821 10.8093 1.3388C10.0593 0.765044 9.05152 0.293176 8.17027 0.116225C7.76245 0.0304303 6.59995 -0.0285548 6.2812 0.0143425ZM7.61714 1.75704C9.07964 1.98762 10.275 2.77586 11.2593 4.14857C11.5546 4.56145 11.7375 4.70087 12 4.70087C12.2625 4.70087 12.45 4.56145 12.7312 4.15929C13.3171 3.31743 13.9265 2.75441 14.7281 2.31471C17.4375 0.829392 20.6578 2.13776 21.9609 5.24781C23.1796 8.15946 22.3265 11.3714 19.3171 15.2322C17.7281 17.2698 15.0281 19.8543 12.4125 21.833L12 22.144L11.3343 21.6292C6.98433 18.2939 3.63745 14.4922 2.29683 11.3768C1.31714 9.09784 1.24683 7.10312 2.08589 5.15666C2.39995 4.4274 2.68589 3.9877 3.25308 3.37642C4.42027 2.12167 6.06558 1.51039 7.61714 1.75704Z"
                        fill="#F54438"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_37">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <span className="figures">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                id="share-button"
                onClick={(event) => {
                  postData(newschoolId, post.title, "Thanks");
                  handleClickin(event);
                  handleThumbsClick(i);
                }}
              >
                {thumbs[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"

                  >
                    <g clip-path="url(#clip0_107_16)">
                      <path
                        d="M0.5 21C0.5 23.4 2.83333 23.3334 4 23L6 22.5L7 22L12.5 23.5H21C22.2 23.5 22.1667 21.1667 22 20C22.5 19.6667 23.5 18.8 23.5 18C23.5 17.2 22.5 16.6667 22 16.5C22.3333 16.3334 23 15.7 23 14.5C23 13.3 22 13 21.5 13C22 13 23.1 12.7 23.5 11.5C23.9 10.3 22.3333 9.66669 21.5 9.50003H14.5L15 8.00002C15.1667 7.00003 15.3 4.40006 14.5 2.00006C13.5 -0.999944 11 1.00006 11 3.50006C11 6.00006 8 9.50003 8 10C8 10.4 7 10.5 6.5 10.5001C6.23238 10.3334 5.65772 9.90003 5.5 9.50003C5.34228 9.10003 3.43428 9.33336 2.5 9.50003L0.5 10V21Z"
                        fill="#2295F1"
                      />
                      <path
                        d="M12.1744 0.0286915C11.3391 0.193104 10.9325 0.862092 10.6373 2.57425C10.1305 5.52233 9.55688 7.08141 8.47087 8.49309C7.98635 9.12239 6.87806 10.1939 6.80009 10.1089C6.78895 10.0975 6.72769 9.98414 6.66643 9.85375C6.60517 9.72902 6.44923 9.53059 6.32113 9.41153C5.87002 8.99767 5.94242 9.00901 3.42511 9.00901C1.24195 9.00901 1.15841 9.01468 0.913362 9.12806C0.590344 9.28114 0.300741 9.57595 0.133663 9.92178L0 10.1996V22.3321L0.15594 22.6552C0.323018 23.0011 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68623 23.517 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6496C6.7444 22.5192 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62682 23.2619 10.2753 23.7494 11.5952 23.9195C12.2079 23.9989 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9989 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5746C22.305 20.5065 22.3662 20.4442 22.7115 20.2741C23.3631 19.9453 23.8588 19.2649 23.9758 18.5393C24.076 17.9156 23.8588 17.1673 23.4467 16.7024L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25279 22.1435 8.92397C21.9597 8.88995 20.5005 8.86727 18.4287 8.86727C15.7276 8.86727 15.0092 8.85026 15.0092 8.79357C15.0092 8.75955 15.1819 8.06222 15.3935 7.25149C15.9059 5.27855 15.9226 5.20485 15.917 4.38845C15.9114 3.82718 15.8836 3.56639 15.7722 3.12985C15.5104 2.10936 14.9368 1.16257 14.2685 0.652324C13.6392 0.170426 12.7815 -0.0903657 12.1744 0.0286915ZM13.0989 1.28163C14.0012 1.62179 14.6583 2.68764 14.8087 4.07664C14.8755 4.63791 14.7586 5.28422 14.2239 7.30819C13.9455 8.36836 13.7171 9.33216 13.7116 9.44555C13.706 9.60996 13.7394 9.695 13.8564 9.81406L14.0067 9.9728L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7757 22.305 12.2122C22.0599 12.3483 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7395 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5162L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5175C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8158L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0709 22.6336 17.4677C23.0902 18.0347 22.8842 18.9418 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3727 19.1583 19.4407C18.8186 19.6108 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3683 21.6199 22.5589 20.7623 22.814C20.6119 22.8593 19.2697 22.8707 16.1231 22.8537C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V11.5546L7.43499 11.084C8.69365 10.1315 9.62372 9.01468 10.2976 7.6767C10.9325 6.41243 11.3056 5.16516 11.6621 3.14119C11.9294 1.63313 12.0631 1.26462 12.3916 1.13989C12.503 1.10021 12.7425 1.14556 13.0989 1.28163ZM5.56371 10.2336L5.70851 10.347V22.1847L5.56371 22.2981C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.11386 22.145V10.3867L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                        fill="#2295F1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_107_16">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_46)">
                      <path
                        d="M12.1744 0.0286594C11.3391 0.193072 10.9325 0.86206 10.6373 2.57422C10.1305 5.5223 9.55688 7.08138 8.47088 8.49306C7.98635 9.12236 6.87806 10.1939 6.80009 10.1088C6.78895 10.0975 6.72769 9.98411 6.66643 9.85371C6.60517 9.72899 6.44923 9.53056 6.32113 9.4115C5.87002 8.99764 5.94242 9.00898 3.42511 9.00898C1.24195 9.00898 1.15841 9.01464 0.913362 9.12803C0.590344 9.28111 0.300741 9.57591 0.133663 9.92175L0 10.1995V16.2658V22.332L0.15594 22.6552C0.323018 23.001 0.512374 23.1938 0.885516 23.3979C1.10829 23.5226 1.15284 23.5226 3.39726 23.5226C5.60827 23.5226 5.68624 23.5169 5.93685 23.4036C6.2543 23.2505 6.55504 22.95 6.68871 22.6495C6.7444 22.5191 6.80566 22.4171 6.82237 22.4171C6.84465 22.4171 7.12311 22.5418 7.44056 22.6949C8.62681 23.2618 10.2753 23.7494 11.5952 23.9195C12.2079 23.9988 12.9152 24.0102 16.6243 23.9932C21.4417 23.9762 21.1187 23.9988 21.7369 23.568C22.2994 23.1768 22.6948 22.4001 22.6948 21.6801C22.6948 21.3456 22.5166 20.6369 22.4164 20.5745C22.305 20.5065 22.3662 20.4441 22.7115 20.2741C23.3631 19.9452 23.8588 19.2649 23.9758 18.5392C24.076 17.9156 23.8588 17.1672 23.4467 16.7023L23.2406 16.4699L23.4355 16.2261C24.1762 15.3077 24.1818 14.0094 23.4467 13.1873L23.2406 12.9492L23.4411 12.7111C24.5828 11.3561 23.8588 9.25276 22.1435 8.92393C21.9597 8.88992 20.5005 8.86724 18.4287 8.86724C15.7276 8.86724 15.0092 8.85023 15.0092 8.79354C15.0092 8.75952 15.1819 8.06219 15.3935 7.25146C15.9059 5.27852 15.9226 5.20481 15.917 4.38842C15.9114 3.82715 15.8836 3.56636 15.7722 3.12982C15.5104 2.10933 14.9368 1.16254 14.2685 0.652292C13.6392 0.170394 12.7815 -0.0903978 12.1744 0.0286594ZM13.0989 1.28159C14.0012 1.62176 14.6583 2.6876 14.8087 4.0766C14.8755 4.63787 14.7586 5.28419 14.2239 7.30816C13.9455 8.36833 13.7171 9.33213 13.7116 9.44552C13.706 9.60993 13.7394 9.69497 13.8564 9.81403L14.0067 9.97277L18.0333 10.0011L22.0543 10.0295L22.3161 10.1882C23.0791 10.6418 23.0735 11.7756 22.305 12.2122C22.0599 12.3482 22.0265 12.3539 20.5896 12.3823L19.1193 12.4106L18.9857 12.5694C18.8409 12.7394 18.8075 13.0399 18.9077 13.2327C19.0302 13.4651 19.1583 13.4878 20.6732 13.5161L22.1267 13.5445L22.3718 13.7146C22.9844 14.1568 23.0624 14.9959 22.5389 15.5174C22.1992 15.8576 21.9819 15.8973 20.4838 15.8973H19.175L19.0135 16.0617C18.7908 16.2885 18.7908 16.5663 19.0135 16.8157L19.175 17.0028L20.6453 17.0312C22.2771 17.0652 22.3105 17.0708 22.6336 17.4677C23.0902 18.0346 22.8842 18.9417 22.227 19.2479C22.0265 19.3386 21.8427 19.3556 20.6732 19.3556C19.5872 19.3556 19.3087 19.3726 19.1583 19.4407C18.8186 19.6107 18.7462 20.0473 19.0135 20.3251C19.175 20.4895 19.1862 20.4895 19.8266 20.4895C20.5952 20.4895 20.8848 20.5519 21.1633 20.79C21.8539 21.3682 21.6199 22.5588 20.7623 22.8139C20.6119 22.8593 19.2697 22.8706 16.1231 22.8536C11.3223 22.831 11.5897 22.848 10.2252 22.4965C9.10577 22.213 7.78585 21.6744 7.08969 21.2152L6.82237 21.0451V16.2998V11.5545L7.43499 11.084C8.69365 10.1315 9.62372 9.01464 10.2976 7.67667C10.9325 6.41239 11.3056 5.16513 11.6621 3.14116C11.9294 1.6331 12.0631 1.26459 12.3916 1.13986C12.503 1.10017 12.7425 1.14553 13.0989 1.28159ZM5.56371 10.2336L5.70851 10.347V16.2658V22.1846L5.56371 22.298C5.41891 22.4114 5.35208 22.4171 3.41954 22.4171H1.42574L1.2698 22.281L1.11386 22.145V16.2658V10.3866L1.2698 10.2506L1.42574 10.1145H3.41954C5.35208 10.1145 5.41891 10.1202 5.56371 10.2336Z"
                        fill="#2295F1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_46">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <span className="figures">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Helpful");
                  handleClickin(event);
                  handleHelpfulClick(index);
                }}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"

                >
                  <g clip-path="url(#clip0_4_40)">
                    <path
                      d="M13.6112 0.0937247C12.9923 0.206225 12.9658 0.224975 9.7441 3.0656C7.25771 5.26404 6.71811 5.71872 6.73927 5.60154C6.92442 4.59372 6.71811 3.9281 6.06212 3.38435C5.58071 2.9906 5.27388 2.88747 4.54912 2.88747C3.84023 2.88747 3.51753 2.9906 3.06257 3.36091C2.71342 3.65154 2.51768 3.91404 2.4013 4.25622C2.35369 4.38747 2.20556 5.75622 2.03627 7.59372C1.87757 9.30935 1.72415 10.8468 1.69241 11.0156C1.53899 11.8406 1.12107 12.5906 0.422762 13.289C0.015416 13.6968 -0.0692273 13.95 0.0577376 14.3672C0.105349 14.5172 0.301087 14.7187 1.03643 15.3797L1.95692 16.2L1.81938 16.3172C1.52312 16.5609 1.39087 16.9359 1.48609 17.2781C1.54429 17.4984 1.70299 17.6437 5.0993 20.6672C7.52222 22.8234 8.7178 23.85 8.86064 23.9109C9.31031 24.0984 9.71236 23.9953 10.2678 23.5547C10.8498 23.0906 11.2306 22.9031 12.3416 22.5234C14.1297 21.9187 15.9548 20.9297 17.8328 19.5422C18.7322 18.8812 23.4616 14.7047 23.6891 14.3765C23.943 14.0062 24.0541 13.4906 23.9748 13.0734C23.8213 12.2765 23.1865 11.6437 22.3348 11.4422L22.1126 11.3859L22.4089 11.0718C22.7739 10.6922 22.9326 10.3968 23.0119 9.96091C23.1601 9.15466 22.6575 8.28747 21.8322 7.92185C21.6524 7.84216 21.4196 7.76716 21.3085 7.7531L21.1075 7.72029L21.2662 7.54685C21.6418 7.12497 21.8163 6.53904 21.7317 5.98591C21.6153 5.21716 20.8906 4.5281 20.0177 4.35466C19.7849 4.30779 19.7373 4.27966 19.7637 4.22341C20.0071 3.72654 20.0653 3.1781 19.9172 2.73279C19.732 2.17966 19.1765 1.66872 18.5206 1.44841C17.9228 1.24685 17.0816 1.33591 16.5314 1.66404C16.4256 1.72966 16.3357 1.78122 16.3251 1.78122C16.3145 1.78122 16.2934 1.70154 16.2722 1.6031C16.1929 1.13904 15.6586 0.520287 15.1401 0.285912C14.6693 0.0749747 14.1244 0.00466223 13.6112 0.0937247ZM14.6852 0.974975C15.1613 1.1906 15.4152 1.5656 15.4205 2.03904C15.4205 2.31091 15.394 2.40935 15.2724 2.60622C15.1666 2.77029 14.1085 3.73591 11.6274 5.93435C8.27343 8.90154 8.13588 9.01404 8.16233 8.83591C8.24697 8.31091 8.26284 7.6406 8.19936 7.40154C8.10414 7.04997 7.91369 6.72654 7.64389 6.47341L7.41112 6.2531L10.3313 3.67029C13.0399 1.27497 13.3891 0.989037 13.7541 0.885912C13.9657 0.824975 14.4577 0.87185 14.6852 0.974975ZM18.1502 2.18435C18.3671 2.2406 18.4994 2.3156 18.711 2.50779C19.002 2.77497 19.0972 2.97185 19.0972 3.32341C19.0972 3.72654 19.002 3.88122 18.4412 4.39685L17.9122 4.87966L17.8434 4.6406C17.653 3.97497 17.0763 3.44997 16.3198 3.25779L16.0183 3.1781L16.4309 2.8031C16.9441 2.34372 17.0922 2.24529 17.399 2.17497C17.727 2.09529 17.8117 2.09529 18.1502 2.18435ZM4.98292 3.71247C5.2633 3.78747 5.68123 4.12497 5.79232 4.36872C5.89283 4.58435 5.91399 5.00622 5.84522 5.55466L5.81348 5.84997L5.56484 5.8781C4.78718 5.97185 4.00952 6.62341 3.81378 7.36404C3.78204 7.47654 3.62334 8.99529 3.46463 10.7343C3.25831 12.9515 3.14193 14.0109 3.06786 14.2875C2.97264 14.6484 2.56529 15.5156 2.49123 15.5156C2.42775 15.5156 0.89888 14.1281 0.89888 14.0718C0.89888 14.0343 1.02055 13.889 1.16868 13.7437C1.88286 13.05 2.41717 12.0703 2.58646 11.1328C2.6182 10.95 2.7769 9.39841 2.93561 7.6781C3.12077 5.62966 3.24773 4.49529 3.29534 4.39216C3.55985 3.83435 4.30577 3.52966 4.98292 3.71247ZM16.2934 4.0781C16.7642 4.28904 17.034 4.67341 17.034 5.13279C17.034 5.64841 17.0552 5.62497 14.1508 8.2031C12.6855 9.50622 11.4581 10.6265 11.4317 10.6968C11.3312 10.9406 11.5428 11.2031 11.8443 11.2031C12.0242 11.2031 12.2093 11.0437 15.3676 8.25935C17.5736 6.30935 18.7745 5.28279 18.912 5.22185C19.2189 5.0906 19.8431 5.09997 20.1341 5.23591C20.4144 5.36716 20.7001 5.66247 20.7795 5.90154C20.8747 6.1781 20.8535 6.55779 20.7319 6.79685C20.6525 6.95622 19.8431 7.70154 17.2985 9.96091C14.1138 12.7875 13.9657 12.9234 13.9657 13.0875C13.9657 13.3172 14.2249 13.5234 14.463 13.4812C14.5899 13.4578 15.2406 12.9093 17.2985 11.0906C19.1501 9.45466 20.0441 8.69529 20.2081 8.62029C20.552 8.4656 21.044 8.47497 21.4037 8.63904C21.8693 8.84997 22.1232 9.20154 22.1285 9.65622C22.1391 10.1765 22.2237 10.0875 19.2823 12.7031C17.3567 14.4093 16.5526 15.1593 16.5261 15.2531C16.4521 15.525 16.7589 15.7968 17.0657 15.7312C17.1715 15.7078 17.8117 15.1781 19.1501 13.9968C21.2397 12.1593 21.2027 12.1828 21.774 12.1875C22.2872 12.1922 22.6892 12.4078 22.9326 12.8062C23.1336 13.1297 23.1442 13.5562 22.9696 13.8797C22.885 14.0297 22.192 14.6765 20.4356 16.2234C19.1025 17.3953 17.7429 18.5625 17.4096 18.8109C15.5686 20.2031 13.807 21.164 11.8813 21.8297C11.4793 21.9656 11.0296 22.1343 10.8762 22.2047C10.4794 22.3828 9.89752 22.7484 9.62772 22.9922C9.50075 23.1093 9.35792 23.2031 9.31031 23.2031C9.26798 23.2031 7.67034 21.825 5.77116 20.1375C2.54413 17.2781 2.31666 17.0625 2.38543 16.9781C2.42775 16.9312 2.6182 16.7156 2.80864 16.5047C3.16309 16.1156 3.55985 15.5015 3.7503 15.0468C4.00952 14.4281 4.06771 14.0343 4.36396 10.8047C4.52796 9.05154 4.68667 7.53747 4.71841 7.43904C4.79247 7.21404 5.13633 6.86716 5.39026 6.75466C6.00922 6.47341 6.75514 6.6656 7.14132 7.20466C7.35293 7.49997 7.37409 7.6781 7.27887 8.67185C7.14661 10.0359 7.16248 10.1578 7.49577 10.3078C7.81318 10.4531 7.68621 10.5515 11.4528 7.22341C14.7328 4.32185 15.0184 4.0781 15.2618 4.01247C15.5845 3.92341 16.0077 3.95154 16.2934 4.0781Z"
                      fill="#4EAF51"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_40">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <span className="figures">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Share");
                  handleClickin(event);
                  handleShareClick(i);
                  openShareModal();
                }}
              >
                {share[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_110_30)">
                      <rect x="1" y="9" width="22" height="15" fill="black" />
                      <path
                        d="M0 10C0 9.44772 0.447715 9 1 9V23H0V10Z"
                        fill="black"
                      />
                      <path
                        d="M23 9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                        fill="black"
                      />
                      <path
                        d="M24 23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23H24Z"
                        fill="black"
                      />
                      <path d="M6 9V10L1 10L1 9H6Z" fill="black" />
                      <path d="M23 9V10L18 10V9L23 9Z" fill="black" />
                      <rect x="11" y="9" width="2" height="7" fill="white" />
                      <path
                        d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_110_30">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_64)">
                      <path
                        d="M12.3536 0.146447C12.1583 -0.0488155 11.8417 -0.0488155 11.6464 0.146447L8.46447 3.32843C8.2692 3.52369 8.2692 3.84027 8.46447 4.03553C8.65973 4.2308 8.97631 4.2308 9.17157 4.03553L12 1.20711L14.8284 4.03553C15.0237 4.2308 15.3403 4.2308 15.5355 4.03553C15.7308 3.84027 15.7308 3.52369 15.5355 3.32843L12.3536 0.146447ZM12.5 15L12.5 0.5H11.5L11.5 15H12.5Z"
                        fill="black"
                      />
                      <path
                        d="M0 10C0 9.44772 0.447715 9 1 9V9V23H0V10Z"
                        fill="black"
                      />
                      <path
                        d="M23 9V9C23.5523 9 24 9.44772 24 10V23H23V9Z"
                        fill="black"
                      />
                      <path
                        d="M24 23V23C24 23.5523 23.5523 24 23 24L1 24C0.447716 24 -2.41412e-08 23.5523 0 23V23L24 23Z"
                        fill="black"
                      />
                      <rect
                        x="6"
                        y="9"
                        width="1"
                        height="5"
                        transform="rotate(90 6 9)"
                        fill="black"
                      />
                      <rect
                        x="23"
                        y="9"
                        width="1"
                        height="5"
                        transform="rotate(90 23 9)"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_64">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <>
                {isShareOption && (
                  <div className="modal sharemodal ">
                    <div className="modal-content share-card">
                      <span className="Close shareclose" onClick={closeModal}>
                        &times;
                      </span>
                      <div className="mb-3.5">
                        <h1 className="ml-2 font-bold text-base">
                          Share With:
                        </h1>
                      </div>
                      <div className="d-flex contents ml-2">
                        <FacebookShareButton
                          url={shareCard(index)}
                          className="ml-2"
                        >
                          <FacebookIcon></FacebookIcon>
                        </FacebookShareButton>

                        <TwitterShareButton
                          url={shareCard(index)}
                          className="ml-2"
                        >
                          <TwitterIcon></TwitterIcon>
                        </TwitterShareButton>
                        <WhatsappShareButton
                          url={window.location.href}
                          className="ml-2"
                        >
                          <WhatsappIcon></WhatsappIcon>
                        </WhatsappShareButton>
                        <LinkedinShareButton
                          url={window.location.href}
                          className="ml-2"
                        >
                          <LinkedinIcon></LinkedinIcon>
                        </LinkedinShareButton>
                        <EmailShareButton
                          className="ml-2"
                          url={shareCard(index)}
                        >
                          <EmailIcon></EmailIcon>
                        </EmailShareButton>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <span className="figures">0</span>
            </div>
            <div className=" text-sm mb-2 flex gap-1">
              <button
                onClick={(event) => {
                  postData(newschoolId, post.title, "Support");
                  handleClickin(event);
                  handleSupportClick(i);
                  openSupportModel();
                }}
              >
                {support[i] ? (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_110_26)">
                      <path
                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
                        fill="#FCD12A"
                      />
                      <path
                        d="M11.9998 0C5.38038 0 0 5.38038 0 11.9998C0 18.6192 5.38038 24 11.9998 24C18.6192 24 24 18.6196 24 11.9998C24 5.37994 18.6196 0 11.9998 0ZM11.9998 1.33327C17.8989 1.33327 22.6666 6.10099 22.6666 12.0001C22.6666 17.8992 17.8989 22.6669 11.9998 22.6669C6.10112 22.6669 1.33297 17.8992 1.33297 12.0001C1.33297 6.10143 6.10068 1.33327 11.9998 1.33327Z"
                        fill="#FCD12A"
                      />
                      <path
                        d="M12.0136 6.00004C10.3356 6.01744 8.8123 7.10205 8.08658 8.71894C7.9944 8.88159 7.97493 9.07526 8.03248 9.25306C8.0902 9.43069 8.21976 9.57612 8.38965 9.65382C8.55954 9.73136 8.75441 9.73411 8.92637 9.6614C9.0985 9.58869 9.2322 9.44706 9.29492 9.27097C9.82286 8.0945 10.9304 7.34933 12.024 7.33345H12.0345C13.0021 7.34275 13.7444 7.62981 14.2428 8.08348C14.7432 8.53885 15.024 9.16829 15.024 10.0001C15.024 10.4326 14.88 10.7689 14.5969 11.1459C14.3138 11.5229 13.8855 11.9074 13.4303 12.3128C12.5198 13.1234 11.3894 14.0954 11.3573 15.6461C11.3529 15.823 11.419 15.9946 11.5412 16.1228C11.6633 16.251 11.8313 16.3253 12.0085 16.3294C12.1854 16.3335 12.3569 16.2672 12.4849 16.1449C12.6127 16.0225 12.6868 15.8544 12.6908 15.6772C12.7092 14.7795 13.4055 14.1233 14.3158 13.3126C14.771 12.9074 15.2631 12.4761 15.6595 11.9482C16.056 11.42 16.3575 10.7675 16.3575 10.0001C16.3575 8.84316 15.9188 7.804 15.1387 7.09376C14.3585 6.3837 13.2623 6.00895 12.024 6L12.0136 6.00004ZM11.6907 17.3338C11.506 17.3338 11.3573 17.4825 11.3573 17.667V18.3338C11.3573 18.5185 11.506 18.667 11.6907 18.667H12.3574C12.5421 18.667 12.6908 18.5185 12.6908 18.3338V17.667C12.6908 17.4825 12.5421 17.3338 12.3574 17.3338H11.6907Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_110_26">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4_67)">
                      <circle cx="12" cy="12" r="11.5" stroke="black" />
                      <path
                        d="M11.208 14.3426V14.2744C11.2156 13.551 11.2913 12.9752 11.4353 12.5472C11.5792 12.1191 11.7837 11.7726 12.0489 11.5074C12.314 11.2423 12.6322 10.9979 13.0034 10.7744C13.2269 10.6381 13.4277 10.4771 13.6057 10.2915C13.7837 10.1021 13.9239 9.8843 14.0262 9.63808C14.1322 9.39187 14.1853 9.11914 14.1853 8.8199C14.1853 8.44869 14.0981 8.12672 13.9239 7.85399C13.7497 7.58127 13.5167 7.37104 13.225 7.22331C12.9334 7.07558 12.6095 7.00172 12.2534 7.00172C11.9428 7.00172 11.6436 7.06611 11.3557 7.1949C11.0678 7.32369 10.8273 7.52634 10.6341 7.80286C10.4409 8.07937 10.3292 8.44111 10.2989 8.88808H8.86708C8.89738 8.24414 9.06405 7.69301 9.36708 7.23467C9.67389 6.77634 10.0773 6.42596 10.5773 6.18354C11.0811 5.94111 11.6398 5.8199 12.2534 5.8199C12.9201 5.8199 13.4997 5.95248 13.9921 6.21763C14.4883 6.48278 14.8709 6.84642 15.1398 7.30854C15.4125 7.77066 15.5489 8.29717 15.5489 8.88808C15.5489 9.30475 15.4845 9.68164 15.3557 10.0188C15.2307 10.3559 15.0489 10.657 14.8103 10.9222C14.5754 11.1873 14.2913 11.4222 13.958 11.6267C13.6247 11.8351 13.3576 12.0548 13.1568 12.2858C12.9561 12.5131 12.8103 12.7839 12.7193 13.0983C12.6284 13.4127 12.5792 13.8048 12.5716 14.2744V14.3426H11.208ZM11.9353 17.7063C11.655 17.7063 11.4144 17.6059 11.2137 17.4051C11.0129 17.2044 10.9125 16.9638 10.9125 16.6835C10.9125 16.4032 11.0129 16.1627 11.2137 15.9619C11.4144 15.7612 11.655 15.6608 11.9353 15.6608C12.2156 15.6608 12.4561 15.7612 12.6568 15.9619C12.8576 16.1627 12.958 16.4032 12.958 16.6835C12.958 16.8691 12.9106 17.0396 12.8159 17.1949C12.725 17.3502 12.6019 17.4752 12.4466 17.5699C12.2951 17.6608 12.1247 17.7063 11.9353 17.7063Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4_67">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
              <>
                {showModalsupport && (
                  <div className="modal sharemodal">
                    <div className="modal-content">
                      <span
                        className="Close shareclose closesupport"
                        onClick={closeModalsupport}
                      >
                        &times;
                      </span>
                      <h2 className="flex justify-center font-bold">
                        Contact Us
                      </h2>
                      <p className="mt-2 mb-4 font-medium">
                        Have a question? Select an option below to contct us
                      </p>
                      <div className="flex justify-around items-center ">
                        <button
                          onClick={() => handlePhoneClick("123-456-7890")}
                          className="flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-telephone"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                          </svg>
                          <span className="ml-1.5">Call</span>
                        </button>
                        <button
                          onClick={() =>
                            handleEmailClick("example@example.com")
                          }
                          className="flex items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-envelope"
                            viewBox="0 0 16 16"
                          >
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                          </svg>
                          <span className="ml-1.5">Email</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <span className="figures">0</span>
            </div>
          </div>
        </div>
        <div className="text-center flex justify-center ">
          <span className="figures">0 View</span>
          {/* <span className="figures">views</span> */}
        </div>
      </>
    );
  }

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="">
          <div
            className="py-9 px-10   2xl:gap-10 h-500 mx-auto flex justify-center items-center"
            id="scroll"
            onScroll={handleScroll}
            ref={cardRef}
          >
            {posts &&
                posts.map((post, index) => (
                <div
                  key={index}
                  className="card w-full h-550 flex justify-center colorcardlatest post"
                >
                  <div className="w-2/3 cardDiv h-auto rounded  PostShadowNew px-4 py-4">
                    <img
                      className="w-full max-h-[25rem] object-contain cursor-pointer  imageheight"
                      src={
                        post.media ||
                        post.big_picture ||
                        post.ios_attachments ||                       
                        logo.Full_Logo__c
                      }
                      alt="Card"
                      onClick={() => {
                        handleClick(index);

                      }}
                      onError={(e) => {
                        e.target.src = logo.Full_Logo__c;
                      }}
                    ></img>
                    <div className="cardInnerText">
                      <div className=" pt-7">
                        {returnInteraction(post, index)}
                      </div>
                      <div
                        className="text-black-700 latestnewsText font-semibold text-md cursor-pointer text-ellipsis heading overflow-hidden"
                        onClick={() => {
                          handleClick(index);

                        }}
                      >
                        {" "}
                        {post.title}
                      </div>
                      <small className="Newsdate">
                        {(() => {
                          const timestamp = post.date;
                          const date = new Date(timestamp);
                          const month = date.getUTCMonth() + 1;
                          const day = date.getUTCDate();
                          const year = date.getUTCFullYear();
                          return `${month}/${day}/${year}`;
                        })()}
                      </small>

                      <div className=" py-1 h-auto text-ellipsis para ">
                        <p
                          className="text-black-700 Newstext text-sm cursor-pointer"
                          onClick={() => {
                            handleClick(index);
                            // let codeExecuted = false;
                            // let newschoolId;
                            // interactions.forEach((respp, indexx) => {
                            //   let newid = post.id;
                            //   let schoopAppC = respp.School_App__c;
                            //   newschoolId = newid.concat(schoopAppC);
                            //   if (newschoolId === respp.Notification_Id__c) {
                            //     console.log(
                            //       "index",
                            //       newschoolId === respp.Notification_Id__c
                            //     );
                            //     postData(
                            //       respp.Notification_Id__c,
                            //       post.headings.en,
                            //       "view"
                            //     );
                            //     codeExecuted = true;
                            //   }
                            // });
                            // if (!codeExecuted) {
                            //   console.log("elseeeeee");
                            //   postData(newschoolId, post.headings.en, "view");
                            // }
                          }}
                        >
                          {post.description}
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
